import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2331 2331"
      id="vector">
      <g
        id="group"
        transform="translate(232 233)">
        <path
          id="path"
          d="M 21.5 0 L 86 0.5 L 21.5 1 L 21.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 114.5 1 L 134 1.5 L 114.5 2 L 114.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 150.5 2 L 163 2.5 L 150.5 3 L 150.5 2 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 175.5 3 L 185 3.5 L 175.5 4 L 175.5 3 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 194.5 4 L 203 4.5 L 194.5 5 L 194.5 4 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 10.5 5 L 6.5 10 L 10.5 5 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 210.5 5 L 218 5.5 L 210.5 6 L 210.5 5 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 224.5 6 L 231 6.5 L 224.5 7 L 224.5 6 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 237.5 7 L 243 7.5 L 237.5 8 L 237.5 7 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 248.5 8 L 253 8.5 L 248.5 9 L 248.5 8 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 258.5 9 L 263 9.5 L 258.5 10 L 258.5 9 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 267.5 10 L 272 10.5 L 267.5 11 L 267.5 10 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 276.5 11 L 280 11.5 L 276.5 12 L 276.5 11 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 284.5 12 L 288 12.5 L 284.5 13 L 284.5 12 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 292.5 13 L 295 13.5 L 292.5 14 L 292.5 13 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 299.5 14 L 302 14.5 L 299.5 15 L 299.5 14 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 305.5 15 L 309 15.5 L 305.5 16 L 305.5 15 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 312.5 16 L 315 16.5 L 312.5 17 L 312.5 16 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 318.5 17 L 321 17.5 L 318.5 18 L 318.5 17 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 323.5 18 L 326 18.5 L 323.5 19 L 323.5 18 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 348.5 23 L 351 23.5 L 348.5 24 L 348.5 23 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 2.5 27 L 3 29.5 L 2 29.5 L 2.5 27 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 5.5 36 L 6.5 38 L 5.5 36 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 11.5 42 L 12.5 44 L 11.5 42 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 67.5 47 L 103 47.5 L 67.5 48 L 67.5 47 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 125.5 48 L 142 48.5 L 125.5 49 L 125.5 48 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 156.5 49 L 168 49.5 L 156.5 50 L 156.5 49 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 178.5 50 L 188 50.5 L 178.5 51 L 178.5 50 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 197.5 51 L 204 51.5 L 197.5 52 L 197.5 51 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 212.5 52 L 219 52.5 L 212.5 53 L 212.5 52 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 225.5 53 L 231 53.5 L 225.5 54 L 225.5 53 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 237.5 54 L 242 54.5 L 237.5 55 L 237.5 54 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 248.5 55 L 253 55.5 L 248.5 56 L 248.5 55 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 257.5 56 L 262 56.5 L 257.5 57 L 257.5 56 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 266.5 57 L 271 57.5 L 266.5 58 L 266.5 57 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 275.5 58 L 278 58.5 L 275.5 59 L 275.5 58 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 282.5 59 L 286 59.5 L 282.5 60 L 282.5 59 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 289.5 60 L 293 60.5 L 289.5 61 L 289.5 60 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 296.5 61 L 299 61.5 L 296.5 62 L 296.5 61 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 303.5 62 L 306 62.5 L 303.5 63 L 303.5 62 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 309.5 63 L 312 63.5 L 309.5 64 L 309.5 63 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 314.5 64 L 317 64.5 L 314.5 65 L 314.5 64 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 478.5 76 L 479.5 78 L 478.5 76 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 481.5 78 L 482.5 80 L 481.5 78 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 485.5 81 L 486.5 83 L 485.5 81 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 391 84 L 393 84.5 L 391 85.5 L 391 84 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 489.5 84 L 491.5 87 L 489.5 84 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 494.5 88 L 497.5 92 L 494.5 88 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 500.5 93 L 506.5 100 L 500.5 93 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 369.5 95 L 368.5 97 L 369.5 95 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 360.5 101 L 359.5 103 L 360.5 101 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 356.5 104 L 352.5 109 L 356.5 104 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 518.5 111 L 525.5 119 L 518.5 111 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 344.5 116 L 340.5 121 L 344.5 116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 527.5 121 L 530.5 125 L 527.5 121 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 338.5 123 L 337.5 125 L 338.5 123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 418.5 126 L 422 126.5 L 418.5 127 L 418.5 126 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 434.5 126 L 438 126.5 L 434.5 127 L 434.5 126 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 532.5 127 L 534.5 130 L 532.5 127 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 536.5 132 L 537.5 134 L 536.5 132 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 393.5 135 L 392.5 137 L 393.5 135 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 539.5 136 L 540.5 138 L 539.5 136 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 390.5 137 L 389.5 139 L 390.5 137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 465.5 137 L 466.5 139 L 465.5 137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 386.5 140 L 376.5 151 L 386.5 140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 469.5 140 L 479.5 151 L 469.5 140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 542.5 140 L 543.5 142 L 542.5 140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 544.5 143 L 545.5 145 L 544.5 143 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 293.5 153 L 311 153.5 L 293.5 154 L 293.5 153 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 374.5 153 L 373.5 155 L 374.5 153 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 282.5 154 L 286 154.5 L 282.5 155 L 282.5 154 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 318.5 154 L 322 154.5 L 318.5 155 L 318.5 154 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 275.5 155 L 278 155.5 L 275.5 156 L 275.5 155 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 552.5 155 L 553.5 157 L 552.5 155 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 269.5 156 L 272 156.5 L 269.5 157 L 269.5 156 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 370.5 160 L 369.5 162 L 370.5 160 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 561.5 170 L 562.5 172 L 561.5 170 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 218.5 174 L 217.5 176 L 218.5 174 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 492.5 177 L 493 179.5 L 492 179.5 L 492.5 177 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 493.5 182 L 494 186.5 L 493 186.5 L 493.5 182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 199.5 185 L 198.5 187 L 199.5 185 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 196.5 187 L 195.5 189 L 196.5 187 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 193.5 189 L 192.5 191 L 193.5 189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 408.5 189 L 409.5 191 L 408.5 189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 190.5 191 L 189.5 193 L 190.5 191 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 412.5 192 L 413.5 194 L 412.5 192 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 186.5 194 L 185.5 196 L 186.5 194 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 416.5 195 L 418.5 198 L 416.5 195 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 183.5 196 L 181.5 199 L 183.5 196 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 493.5 198 L 494 201.5 L 493 201.5 L 493.5 198 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 179.5 199 L 177.5 202 L 179.5 199 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 421.5 199 L 425.5 204 L 421.5 199 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 291.5 200 L 298 200.5 L 291.5 201 L 291.5 200 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 308.5 200 L 315 200.5 L 308.5 201 L 308.5 200 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 283.5 201 L 286 201.5 L 283.5 202 L 283.5 201 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 319.5 201 L 322 201.5 L 319.5 202 L 319.5 201 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 174.5 203 L 172.5 206 L 174.5 203 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 430.5 207 L 440.5 218 L 430.5 207 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 168.5 208 L 165.5 212 L 168.5 208 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 160.5 215 L 136.5 240 L 160.5 215 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 235.5 218 L 234.5 220 L 235.5 218 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 372.5 221 L 373.5 223 L 372.5 221 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 228.5 222 L 227.5 224 L 228.5 222 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 444.5 222 L 447.5 226 L 444.5 222 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 375.5 223 L 376.5 225 L 375.5 223 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 378.5 225 L 379.5 227 L 378.5 225 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 484.5 226 L 483.5 228 L 484.5 226 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 382.5 228 L 383.5 230 L 382.5 228 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 450.5 229 L 452.5 232 L 450.5 229 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 482.5 229 L 481.5 231 L 482.5 229 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 216.5 230 L 215.5 232 L 216.5 230 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 386.5 231 L 388.5 234 L 386.5 231 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 213.5 232 L 212.5 234 L 213.5 232 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 480.5 232 L 477.5 236 L 480.5 232 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 454.5 234 L 455.5 236 L 454.5 234 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 209.5 235 L 207.5 238 L 209.5 235 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 391.5 235 L 395.5 240 L 391.5 235 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 457.5 238 L 458.5 240 L 457.5 238 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 204.5 239 L 202.5 242 L 204.5 239 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 472.5 240 L 469.5 244 L 472.5 240 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 459.5 241 L 460.5 243 L 459.5 241 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 133.5 243 L 129.5 248 L 133.5 243 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 199.5 243 L 195.5 248 L 199.5 243 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 127.5 250 L 124.5 254 L 127.5 250 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 191.5 250 L 172.5 270 L 191.5 250 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 408.5 252 L 412.5 257 L 408.5 252 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 523.5 252 L 522.5 254 L 523.5 252 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 521.5 255 L 520.5 257 L 521.5 255 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 122.5 256 L 119.5 260 L 122.5 256 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 519.5 258 L 518.5 260 L 519.5 258 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 414.5 259 L 416.5 262 L 414.5 259 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 117.5 262 L 116.5 264 L 117.5 262 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 516.5 262 L 514.5 265 L 516.5 262 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 418.5 264 L 419.5 266 L 418.5 264 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 114.5 266 L 112.5 269 L 114.5 266 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 1156.5 266 L 1169 266.5 L 1156.5 267 L 1156.5 266 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 1187.5 266 L 1198 266.5 L 1187.5 267 L 1187.5 266 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1142.5 267 L 1148 267.5 L 1142.5 268 L 1142.5 267 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 1205.5 267 L 1210 267.5 L 1205.5 268 L 1205.5 267 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 421.5 268 L 422.5 270 L 421.5 268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 511.5 268 L 505.5 275 L 511.5 268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 1132.5 268 L 1137 268.5 L 1132.5 269 L 1132.5 268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 1214.5 268 L 1218 268.5 L 1214.5 269 L 1214.5 268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1124.5 269 L 1128 269.5 L 1124.5 270 L 1124.5 269 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1222.5 269 L 1225 269.5 L 1222.5 270 L 1222.5 269 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 1117.5 270 L 1120 270.5 L 1117.5 271 L 1117.5 270 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 1228.5 270 L 1231 270.5 L 1228.5 271 L 1228.5 270 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 110.5 271 L 109.5 273 L 110.5 271 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 423.5 271 L 424.5 273 L 423.5 271 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 1110.5 271 L 1113 271.5 L 1110.5 272 L 1110.5 271 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 1233.5 271 L 1236 271.5 L 1233.5 272 L 1233.5 271 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 1104.5 272 L 1107 272.5 L 1104.5 273 L 1104.5 272 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 1238.5 272 L 1241 272.5 L 1238.5 273 L 1238.5 272 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 169.5 273 L 164.5 279 L 169.5 273 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 107.5 275 L 106.5 277 L 107.5 275 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 501.5 277 L 498.5 281 L 501.5 277 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 1075.5 278 L 1078 278.5 L 1075.5 279 L 1075.5 278 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 104.5 279 L 103.5 281 L 104.5 279 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 162.5 281 L 159.5 285 L 162.5 281 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 496.5 281 L 494.5 284 L 496.5 281 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 102.5 282 L 101.5 284 L 102.5 282 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 492.5 284 L 491.5 286 L 492.5 284 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 489.5 286 L 488.5 288 L 489.5 286 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 157.5 287 L 155.5 290 L 157.5 287 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 486.5 288 L 486 289.5 L 485.5 291 L 485 289.5 L 486.5 288 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 97.5 289 L 96.5 291 L 97.5 289 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 95.5 292 L 94.5 294 L 95.5 292 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 153.5 292 L 151.5 295 L 153.5 292 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 149.5 297 L 148.5 299 L 149.5 297 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 146.5 301 L 145.5 303 L 146.5 301 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 1322.5 303 L 1323.5 305 L 1322.5 303 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 143.5 305 L 142.5 307 L 143.5 305 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 85.5 307 L 84.5 309 L 85.5 307 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 141.5 308 L 140.5 310 L 141.5 308 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1332.5 309 L 1333.5 311 L 1332.5 309 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 83.5 310 L 82.5 312 L 83.5 310 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 138.5 312 L 137.5 314 L 138.5 312 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 1152.5 313 L 1160 313.5 L 1152.5 314 L 1152.5 313 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 1194.5 313 L 1201 313.5 L 1194.5 314 L 1194.5 313 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 492.5 314 L 493 316.5 L 492 316.5 L 492.5 314 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 1141.5 314 L 1146 314.5 L 1141.5 315 L 1141.5 314 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1206.5 314 L 1210 314.5 L 1206.5 315 L 1206.5 314 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 1340.5 314 L 1341.5 316 L 1340.5 314 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 136.5 315 L 135.5 317 L 136.5 315 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 1132.5 315 L 1136 315.5 L 1132.5 316 L 1132.5 315 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 1214.5 315 L 1217 315.5 L 1214.5 316 L 1214.5 315 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 1124.5 316 L 1128 316.5 L 1124.5 317 L 1124.5 316 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 1220.5 316 L 1223 316.5 L 1220.5 317 L 1220.5 316 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1343.5 316 L 1344.5 318 L 1343.5 316 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1118.5 317 L 1121 317.5 L 1118.5 318 L 1118.5 317 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 78.5 318 L 77.5 320 L 78.5 318 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 1112.5 318 L 1115 318.5 L 1112.5 319 L 1112.5 318 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 493.5 319 L 494 321.5 L 493 321.5 L 493.5 319 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 1106.5 319 L 1109 319.5 L 1106.5 320 L 1106.5 319 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 1101.5 320 L 1104 320.5 L 1101.5 321 L 1101.5 320 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 1350.5 321 L 1351.5 323 L 1350.5 321 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 961.5 322 L 960.5 324 L 961.5 322 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 75.5 323 L 74.5 325 L 75.5 323 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 1354.5 324 L 1355.5 326 L 1354.5 324 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 494.5 325 L 495 327.5 L 494 327.5 L 494.5 325 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1358.5 327 L 1359.5 329 L 1358.5 327 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 72.5 328 L 71.5 330 L 72.5 328 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 447.5 328 L 448 330.5 L 447 330.5 L 447.5 328 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 1362.5 330 L 1364.5 333 L 1362.5 330 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 495.5 331 L 496 335.5 L 495 335.5 L 495.5 331 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 448.5 334 L 449 336.5 L 448 336.5 L 448.5 334 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 939.5 335 L 938.5 337 L 939.5 335 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1368.5 335 L 1371.5 339 L 1368.5 335 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 122.5 336 L 121.5 338 L 122.5 336 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 1375.5 341 L 1397.5 364 L 1375.5 341 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 64.5 342 L 63.5 344 L 64.5 342 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 449.5 342 L 450 347.5 L 449 347.5 L 449.5 342 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 496.5 342 L 497 353.5 L 496 353.5 L 496.5 342 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1305.5 347 L 1306.5 349 L 1305.5 347 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 918.5 349 L 917.5 351 L 918.5 349 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 914.5 352 L 913.5 354 L 914.5 352 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 1313.5 352 L 1314.5 354 L 1313.5 352 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 58.5 353 L 57.5 355 L 58.5 353 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 911.5 354 L 909.5 357 L 911.5 354 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1316.5 354 L 1317.5 356 L 1316.5 354 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 110.5 356 L 109.5 358 L 110.5 356 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 496.5 357 L 497 369.5 L 496 369.5 L 496.5 357 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 907.5 357 L 905.5 360 L 907.5 357 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1323.5 359 L 1324.5 361 L 1323.5 359 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 902.5 361 L 901.5 363 L 902.5 361 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 985.5 362 L 984.5 364 L 985.5 362 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 1327.5 362 L 1328.5 364 L 1327.5 362 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 449.5 363 L 450 369.5 L 449 369.5 L 449.5 363 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 898.5 364 L 895.5 368 L 898.5 364 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 1331.5 365 L 1333.5 368 L 1331.5 365 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 976.5 367 L 975.5 369 L 976.5 367 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 1400.5 367 L 1403.5 371 L 1400.5 367 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 892.5 369 L 888.5 374 L 892.5 369 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 971.5 370 L 970.5 372 L 971.5 370 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 1337.5 370 L 1340.5 374 L 1337.5 370 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 966.5 373 L 965.5 375 L 966.5 373 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 1405.5 373 L 1408.5 377 L 1405.5 373 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 448.5 374 L 449 377.5 L 448 377.5 L 448.5 374 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 885.5 375 L 878.5 383 L 885.5 375 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 495.5 376 L 496 379.5 L 495 379.5 L 495.5 376 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 1344.5 376 L 1361.5 394 L 1344.5 376 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 958.5 378 L 957.5 380 L 958.5 378 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 1409.5 378 L 1411.5 381 L 1409.5 378 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 955.5 380 L 954.5 382 L 955.5 380 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 447.5 381 L 448 383.5 L 447 383.5 L 447.5 381 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 952.5 382 L 951.5 384 L 952.5 382 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 1413.5 383 L 1414.5 385 L 1413.5 383 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 494.5 384 L 495 386.5 L 494 386.5 L 494.5 384 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 945.5 387 L 944.5 389 L 945.5 387 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 1416.5 387 L 1417.5 389 L 1416.5 387 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 870.5 389 L 868.5 392 L 870.5 389 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 493.5 390 L 494 392.5 L 493 392.5 L 493.5 390 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 941.5 390 L 940.5 392 L 941.5 390 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 1418.5 390 L 1419.5 392 L 1418.5 390 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 938.5 392 L 936.5 395 L 938.5 392 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 492.5 395 L 493 397.5 L 492 397.5 L 492.5 395 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 933.5 396 L 932.5 398 L 933.5 396 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 1364.5 397 L 1367.5 401 L 1364.5 397 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 861.5 399 L 855.5 406 L 861.5 399 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 929.5 399 L 927.5 402 L 929.5 399 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 923.5 404 L 920.5 408 L 923.5 404 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 1370.5 404 L 1372.5 407 L 1370.5 404 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 1428.5 405 L 1429.5 407 L 1428.5 405 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 852.5 409 L 849.5 413 L 852.5 409 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1374.5 409 L 1375.5 411 L 1374.5 409 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 916.5 410 L 909.5 418 L 916.5 410 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 1377.5 413 L 1378.5 415 L 1377.5 413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 847.5 415 L 845.5 418 L 847.5 415 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 843.5 420 L 841.5 423 L 843.5 420 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 1382.5 420 L 1383.5 422 L 1382.5 420 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1384.5 423 L 1385.5 425 L 1384.5 423 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 839.5 425 L 838.5 427 L 839.5 425 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 836.5 429 L 835.5 431 L 836.5 429 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 897.5 429 L 890.5 437 L 897.5 429 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 1389.5 431 L 1390.5 433 L 1389.5 431 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 834.5 432 L 833.5 434 L 834.5 432 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 831.5 436 L 830.5 438 L 831.5 436 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 1392.5 436 L 1393.5 438 L 1392.5 436 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 829.5 439 L 828.5 441 L 829.5 439 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 887.5 440 L 884.5 444 L 887.5 440 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 422.5 446 L 421.5 448 L 422.5 446 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 882.5 446 L 880.5 449 L 882.5 446 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 878.5 451 L 877.5 453 L 878.5 451 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 417.5 454 L 416.5 456 L 417.5 454 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 819.5 454 L 818.5 456 L 819.5 454 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 875.5 455 L 874.5 457 L 875.5 455 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 817.5 457 L 816.5 459 L 817.5 457 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 872.5 459 L 871.5 461 L 872.5 459 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 412.5 461 L 411.5 463 L 412.5 461 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 467.5 462 L 466.5 464 L 467.5 462 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 870.5 462 L 869.5 464 L 870.5 462 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 410.5 464 L 409.5 466 L 410.5 464 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 407.5 468 L 405.5 471 L 407.5 468 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 865.5 469 L 864.5 471 L 865.5 469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 404.5 472 L 402.5 475 L 404.5 472 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 863.5 472 L 862.5 474 L 863.5 472 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 861.5 475 L 860.5 477 L 861.5 475 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 400.5 477 L 397.5 481 L 400.5 477 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 458.5 477 L 457.5 479 L 458.5 477 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 805.5 477 L 804.5 479 L 805.5 477 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 456.5 480 L 455.5 482 L 456.5 480 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 454.5 483 L 453.5 485 L 454.5 483 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 394.5 484 L 389.5 490 L 394.5 484 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 800.5 486 L 799.5 488 L 800.5 486 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 854.5 486 L 853.5 488 L 854.5 486 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 6.5 490 L 7 492.5 L 6 492.5 L 6.5 490 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 449.5 490 L 448.5 492 L 449.5 490 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 851.5 491 L 850.5 493 L 851.5 491 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 385.5 494 L 372.5 508 L 385.5 494 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 446.5 494 L 445.5 496 L 446.5 494 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 5.5 495 L 6 497.5 L 5 497.5 L 5.5 495 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 443.5 498 L 442.5 500 L 443.5 498 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 52.5 499 L 53 501.5 L 52 501.5 L 52.5 499 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 4.5 501 L 5 503.5 L 4 503.5 L 4.5 501 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 440.5 502 L 438.5 505 L 440.5 502 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 51.5 504 L 52 506.5 L 51 506.5 L 51.5 504 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 3.5 507 L 4 509.5 L 3 509.5 L 3.5 507 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 436.5 507 L 433.5 511 L 436.5 507 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1420.5 508 L 1421 510.5 L 1420 510.5 L 1420.5 508 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 50.5 509 L 51 511.5 L 50 511.5 L 50.5 509 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1468.5 510 L 1469 512.5 L 1468 512.5 L 1468.5 510 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 366.5 512 L 361.5 518 L 366.5 512 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 431.5 513 L 427.5 518 L 431.5 513 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 1421.5 513 L 1422 515.5 L 1421 515.5 L 1421.5 513 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 2.5 514 L 3 516.5 L 2 516.5 L 2.5 514 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 49.5 515 L 50 518.5 L 49 518.5 L 49.5 515 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 837.5 516 L 836.5 518 L 837.5 516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 1469.5 517 L 1470 519.5 L 1469 519.5 L 1469.5 517 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 1422.5 519 L 1423 521.5 L 1422 521.5 L 1422.5 519 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 357.5 520 L 353.5 525 L 357.5 520 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 1.5 522 L 2 526.5 L 1 526.5 L 1.5 522 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 48.5 522 L 49 525.5 L 48 525.5 L 48.5 522 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 423.5 522 L 399.5 547 L 423.5 522 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1470.5 524 L 1471 528.5 L 1470 528.5 L 1470.5 524 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 350.5 526 L 348.5 529 L 350.5 526 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 1423.5 526 L 1424 528.5 L 1423 528.5 L 1423.5 526 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 345.5 530 L 343.5 533 L 345.5 530 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 47.5 531 L 48 536.5 L 47 536.5 L 47.5 531 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 0.5 533 L 1 562.5 L 0 562.5 L 0.5 533 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 340.5 534 L 338.5 537 L 340.5 534 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 1424.5 534 L 1425 538.5 L 1424 538.5 L 1424.5 534 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 1471.5 534 L 1472 540.5 L 1471 540.5 L 1471.5 534 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 335.5 538 L 334.5 540 L 335.5 538 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 331.5 541 L 330.5 543 L 331.5 541 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 647.5 542 L 648.5 544 L 647.5 542 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 327.5 544 L 326.5 546 L 327.5 544 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 701.5 545 L 702.5 547 L 701.5 545 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 324.5 546 L 323.5 548 L 324.5 546 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 1425.5 546 L 1426 572.5 L 1425 572.5 L 1425.5 546 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 320.5 549 L 319.5 551 L 320.5 549 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 395.5 549 L 390.5 555 L 395.5 549 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 317.5 551 L 316.5 553 L 317.5 551 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 705.5 552 L 706.5 554 L 705.5 552 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 314.5 553 L 313.5 555 L 314.5 553 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 1472.5 554 L 1473 564.5 L 1472 564.5 L 1472.5 554 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 386.5 557 L 383.5 561 L 386.5 557 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 708.5 557 L 709.5 559 L 708.5 557 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 47.5 561 L 48 565.5 L 47 565.5 L 47.5 561 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 302.5 561 L 301.5 563 L 302.5 561 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 380.5 562 L 377.5 566 L 380.5 562 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 711.5 562 L 712.5 564 L 711.5 562 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 294.5 566 L 293.5 568 L 294.5 566 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 374.5 567 L 372.5 570 L 374.5 567 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 714.5 567 L 715.5 569 L 714.5 567 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 1.5 569 L 2 573.5 L 1 573.5 L 1.5 569 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 48.5 570 L 49 572.5 L 48 572.5 L 48.5 570 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 716.5 570 L 717.5 572 L 716.5 570 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 369.5 571 L 368.5 573 L 369.5 571 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 365.5 574 L 363.5 577 L 365.5 574 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 2.5 577 L 3 579.5 L 2 579.5 L 2.5 577 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 361.5 577 L 359.5 580 L 361.5 577 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 721.5 578 L 722.5 580 L 721.5 578 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 1471.5 578 L 1472 584.5 L 1471 584.5 L 1471.5 578 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 357.5 580 L 356.5 582 L 357.5 580 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1424.5 580 L 1425 585.5 L 1424 585.5 L 1424.5 580 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 723.5 581 L 724.5 583 L 723.5 581 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 3.5 583 L 4 585.5 L 3 585.5 L 3.5 583 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 353.5 583 L 352.5 585 L 353.5 583 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 725.5 584 L 726.5 586 L 725.5 584 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 727.5 587 L 728.5 589 L 727.5 587 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 346.5 588 L 345.5 590 L 346.5 588 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 343.5 590 L 342.5 592 L 343.5 590 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 1423.5 590 L 1424 593.5 L 1423 593.5 L 1423.5 590 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 1470.5 590 L 1471 594.5 L 1470 594.5 L 1470.5 590 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 676.5 593 L 677.5 595 L 676.5 593 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 732.5 594 L 733.5 596 L 732.5 594 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 678.5 596 L 679.5 598 L 678.5 596 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 734.5 597 L 735.5 599 L 734.5 597 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 1422.5 597 L 1423 599.5 L 1422 599.5 L 1422.5 597 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 57.5 598 L 58.5 600 L 57.5 598 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 1469.5 599 L 1470 602.5 L 1469 602.5 L 1469.5 599 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 328.5 600 L 327.5 602 L 328.5 600 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 737.5 601 L 738.5 603 L 737.5 601 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 325.5 602 L 324.5 604 L 325.5 602 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 61.5 604 L 64.5 608 L 61.5 604 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 740.5 605 L 741.5 607 L 740.5 605 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 1468.5 606 L 1469 608.5 L 1468 608.5 L 1468.5 606 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 317.5 607 L 316.5 609 L 317.5 607 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 743.5 609 L 744.5 611 L 743.5 609 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 67.5 610 L 70.5 614 L 67.5 610 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 312.5 610 L 311.5 612 L 312.5 610 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 1419.5 612 L 1420 614.5 L 1419 614.5 L 1419.5 612 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 746.5 613 L 747.5 615 L 746.5 613 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 692.5 617 L 693.5 619 L 692.5 617 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 1466.5 617 L 1467 619.5 L 1466 619.5 L 1466.5 617 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 694.5 620 L 695.5 622 L 694.5 620 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 162.5 622 L 165 622.5 L 162.5 623 L 162.5 622 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 157.5 623 L 160 623.5 L 157.5 624 L 157.5 623 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 289.5 623 L 288.5 625 L 289.5 623 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 18.5 624 L 19.5 626 L 18.5 624 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 152.5 624 L 155 624.5 L 152.5 625 L 152.5 624 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 697.5 624 L 698.5 626 L 697.5 624 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 98.5 625 L 101 625.5 L 98.5 626 L 98.5 625 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 145.5 625 L 148 625.5 L 145.5 626 L 145.5 625 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 104.5 626 L 108 626.5 L 104.5 627 L 104.5 626 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 136.5 626 L 141 626.5 L 136.5 627 L 136.5 626 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 20.5 627 L 21.5 629 L 20.5 627 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 115.5 627 L 129 627.5 L 115.5 628 L 115.5 627 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 699.5 627 L 700.5 629 L 699.5 627 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 22.5 630 L 23.5 632 L 22.5 630 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 702.5 631 L 703.5 633 L 702.5 631 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 25.5 634 L 28.5 638 L 25.5 634 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 705.5 635 L 706.5 637 L 705.5 635 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 708.5 639 L 709.5 641 L 708.5 639 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 791.5 639 L 792 641.5 L 791 641.5 L 791.5 639 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 711.5 643 L 713.5 646 L 711.5 643 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 37.5 646 L 40.5 650 L 37.5 646 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 715.5 648 L 717.5 651 L 715.5 648 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 789.5 648 L 790 650.5 L 789 650.5 L 789.5 648 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 43.5 651 L 44.5 653 L 43.5 651 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 719.5 653 L 721.5 656 L 719.5 653 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 723.5 658 L 726.5 662 L 723.5 658 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 787.5 658 L 788 660.5 L 795 667.5 L 787 660.5 L 787.5 658 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 729.5 665 L 732.5 669 L 729.5 665 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 160.5 670 L 163 670.5 L 160.5 671 L 160.5 670 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 89.5 671 L 92 671.5 L 89.5 672 L 89.5 671 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 154.5 671 L 157 671.5 L 154.5 672 L 154.5 671 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 95.5 672 L 99 672.5 L 95.5 673 L 95.5 672 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 146.5 672 L 150 672.5 L 146.5 673 L 146.5 672 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 735.5 672 Q 738.5 672.5 738 676.5 L 737 676.5 L 735.5 672 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 103.5 673 L 109 673.5 L 103.5 674 L 103.5 673 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 134.5 673 L 141 673.5 L 134.5 674 L 134.5 673 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 801.5 673 L 807.5 680 L 801.5 673 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 736.5 681 L 737 684.5 L 736 684.5 L 736.5 681 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 811.5 682 L 815.5 687 L 811.5 682 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 735.5 688 L 736 691.5 L 735 691.5 L 735.5 688 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 1387.5 688 L 1386.5 690 L 1387.5 688 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 1442.5 688 L 1441.5 690 L 1442.5 688 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 819.5 689 L 821.5 692 L 819.5 689 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 1385.5 691 L 1384.5 693 L 1385.5 691 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 825.5 694 L 827.5 697 L 825.5 694 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 734.5 697 L 735 700.5 L 734 700.5 L 734.5 697 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 830.5 698 L 831.5 700 L 830.5 698 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 1380.5 698 L 1379.5 700 L 1380.5 698 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 834.5 701 L 836.5 704 L 834.5 701 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1435.5 701 L 1434.5 703 L 1435.5 701 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 1377.5 702 L 1376.5 704 L 1377.5 702 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 839.5 705 L 840.5 707 L 839.5 705 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 733.5 706 L 734 711.5 L 733 711.5 L 733.5 706 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 1374.5 706 L 1372.5 709 L 1374.5 706 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 843.5 708 L 844.5 710 L 843.5 708 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 846.5 710 L 847.5 712 L 846.5 710 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 1370.5 711 L 1367.5 715 L 1370.5 711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 1429.5 711 L 1428.5 713 L 1429.5 711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 850.5 713 L 851.5 715 L 850.5 713 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 853.5 715 L 854.5 717 L 853.5 715 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 779.5 716 L 780 719.5 L 779 719.5 L 779.5 716 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 856.5 717 L 857.5 719 L 856.5 717 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1365.5 717 L 1357.5 726 L 1365.5 717 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 732.5 718 L 733 725.5 L 732 725.5 L 732.5 718 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 783.5 719 L 786.5 723 L 783.5 719 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 859.5 719 L 860.5 721 L 859.5 719 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 862.5 721 L 863.5 723 L 862.5 721 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 865.5 723 L 866.5 725 L 865.5 723 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1421.5 723 L 1420.5 725 L 1421.5 723 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 790.5 725 L 793.5 729 L 790.5 725 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 1419.5 726 L 1418.5 728 L 1419.5 726 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 778.5 727 L 779 735.5 L 778 735.5 L 778.5 727 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 873.5 728 L 874.5 730 L 873.5 728 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 796.5 730 L 798.5 733 L 796.5 730 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 1416.5 730 L 1415.5 732 L 1416.5 730 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1349.5 733 L 1342.5 741 L 1349.5 733 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 801.5 734 L 803.5 737 L 801.5 734 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 883.5 734 L 884.5 736 L 883.5 734 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1413.5 734 L 1412.5 736 L 1413.5 734 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 731.5 735 L 732 752.5 L 731 752.5 L 731.5 735 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 806.5 738 L 807.5 740 L 806.5 738 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 1410.5 738 L 1408.5 741 L 1410.5 738 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 810.5 741 L 811.5 743 L 810.5 741 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1338.5 743 L 1335.5 747 L 1338.5 743 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 1406.5 743 L 1403.5 747 L 1406.5 743 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 814.5 744 L 815.5 746 L 814.5 744 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 901.5 744 L 902.5 746 L 901.5 744 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 818.5 747 L 819.5 749 L 818.5 747 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 1332.5 748 L 1330.5 751 L 1332.5 748 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1400.5 750 L 1393.5 758 L 1400.5 750 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 825.5 752 L 826.5 754 L 825.5 752 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 1327.5 752 L 1326.5 754 L 1327.5 752 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 828.5 754 L 829.5 756 L 828.5 754 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 777.5 755 L 778 763.5 L 777 763.5 L 777.5 755 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 1323.5 755 L 1322.5 757 L 1323.5 755 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1320.5 757 L 1319.5 759 L 1320.5 757 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 843.5 764 L 844.5 766 L 843.5 764 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 731.5 766 L 732 783.5 L 731 783.5 L 731.5 766 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 846.5 766 L 847.5 768 L 846.5 766 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1305.5 767 L 1304.5 769 L 1305.5 767 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 1381.5 769 L 1374.5 777 L 1381.5 769 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1370.5 779 L 1367.5 783 L 1370.5 779 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 778.5 782 L 779 790.5 L 778 790.5 L 778.5 782 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 877.5 784 L 878.5 786 L 877.5 784 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 1364.5 784 L 1362.5 787 L 1364.5 784 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1359.5 788 L 1358.5 790 L 1359.5 788 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1355.5 791 L 1354.5 793 L 1355.5 791 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 1038.5 793 L 1041 793.5 L 1038.5 794 L 1038.5 793 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 732.5 794 L 733 800.5 L 732 800.5 L 732.5 794 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 1043.5 794 L 1046 794.5 L 1043.5 795 L 1043.5 794 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 1351.5 794 L 1350.5 796 L 1351.5 794 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 1048.5 795 L 1051 795.5 L 1048.5 796 L 1048.5 795 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 779.5 797 L 780 802.5 L 779 802.5 L 779.5 797 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 1059.5 797 L 1062 797.5 L 1059.5 798 L 1059.5 797 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 1065.5 798 L 1068 798.5 L 1065.5 799 L 1065.5 798 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1072.5 799 L 1075 799.5 L 1072.5 800 L 1072.5 799 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 1078.5 800 L 1082 800.5 L 1078.5 801 L 1078.5 800 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 1086.5 801 L 1090 801.5 L 1086.5 802 L 1086.5 801 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 1094.5 802 L 1098 802.5 L 1094.5 803 L 1094.5 802 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1103.5 803 L 1108 803.5 L 1103.5 804 L 1103.5 803 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 1208.5 803 L 1211 803.5 L 1208.5 804 L 1208.5 803 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 1114.5 804 L 1120 804.5 L 1114.5 805 L 1114.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 1201.5 804 L 1204 804.5 L 1201.5 805 L 1201.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1127.5 805 L 1134 805.5 L 1127.5 806 L 1127.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 1192.5 805 L 1197 805.5 L 1192.5 806 L 1192.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 1144.5 806 L 1158 806.5 L 1144.5 807 L 1144.5 806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 1176.5 806 L 1186 806.5 L 1176.5 807 L 1176.5 806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 1333.5 806 L 1332.5 808 L 1333.5 806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 733.5 807 L 734 811.5 L 733 811.5 L 733.5 807 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 780.5 808 L 781 812.5 L 780 812.5 L 780.5 808 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 1328.5 809 L 1327.5 811 L 1328.5 809 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 734.5 817 L 735 820.5 L 734 820.5 L 734.5 817 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 781.5 817 L 782 820.5 L 781 820.5 L 781.5 817 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 782.5 825 L 783 827.5 L 782 827.5 L 782.5 825 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 735.5 826 L 736 828.5 L 735 828.5 L 735.5 826 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 783.5 832 L 784 834.5 L 783 834.5 L 783.5 832 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 736.5 833 L 737 836.5 L 736 836.5 L 736.5 833 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 784.5 838 L 785 840.5 L 784 840.5 L 784.5 838 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 737.5 840 L 738 842.5 L 737 842.5 L 737.5 840 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 1040.5 841 L 1043 841.5 L 1040.5 842 L 1040.5 841 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 1045.5 842 L 1048 842.5 L 1045.5 843 L 1045.5 842 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 785.5 843 L 786 845.5 L 785 845.5 L 785.5 843 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 1051.5 843 L 1054 843.5 L 1051.5 844 L 1051.5 843 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 1057.5 844 L 1060 844.5 L 1057.5 845 L 1057.5 844 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 1063.5 845 L 1066 845.5 L 1063.5 846 L 1063.5 845 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 738.5 846 L 739 848.5 L 738 848.5 L 738.5 846 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 1070.5 846 L 1073 846.5 L 1070.5 847 L 1070.5 846 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1233.5 846 L 1236 846.5 L 1233.5 847 L 1233.5 846 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 1077.5 847 L 1081 847.5 L 1077.5 848 L 1077.5 847 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 1228.5 847 L 1231 847.5 L 1228.5 848 L 1228.5 847 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 1085.5 848 L 1089 848.5 L 1085.5 849 L 1085.5 848 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 1223.5 848 L 1226 848.5 L 1223.5 849 L 1223.5 848 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 1094.5 849 L 1098 849.5 L 1094.5 850 L 1094.5 849 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 1217.5 849 L 1220 849.5 L 1217.5 850 L 1217.5 849 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 1104.5 850 L 1109 850.5 L 1104.5 851 L 1104.5 850 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 1210.5 850 L 1213 850.5 L 1210.5 851 L 1210.5 850 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 1115.5 851 L 1122 851.5 L 1115.5 852 L 1115.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 1201.5 851 L 1206 851.5 L 1201.5 852 L 1201.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 1129.5 852 L 1139 852.5 L 1129.5 853 L 1129.5 852 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 1190.5 852 L 1196 852.5 L 1190.5 853 L 1190.5 852 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 1151.5 853 L 1181 853.5 L 1151.5 854 L 1151.5 853 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 740.5 857 L 741 859.5 L 740 859.5 L 740.5 857 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 788.5 858 L 789 860.5 L 788 860.5 L 788.5 858 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 741.5 862 L 742 864.5 L 741 864.5 L 741.5 862 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 743.5 871 L 744 873.5 L 743 873.5 L 743.5 871 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 838.5 988 L 839.5 990 L 838.5 988 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 843.5 996 L 844.5 998 L 843.5 996 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 791.5 1000 L 792.5 1002 L 791.5 1000 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 781.5 1003 L 789 1003.5 L 781.5 1004 L 781.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 769.5 1004 L 773 1004.5 L 769.5 1005 L 769.5 1004 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 763.5 1005 L 766 1005.5 L 763.5 1006 L 763.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 853.5 1011 L 854.5 1013 L 853.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 855.5 1014 L 856.5 1016 L 855.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 727.5 1018 L 726.5 1020 L 727.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 858.5 1018 L 859.5 1020 L 858.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 722.5 1021 L 721.5 1023 L 722.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 861.5 1022 L 862.5 1024 L 861.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 719.5 1023 L 718.5 1025 L 719.5 1023 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 715.5 1026 L 714.5 1028 L 715.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 864.5 1026 L 866.5 1029 L 864.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 711.5 1029 L 709.5 1032 L 711.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 868.5 1031 L 871.5 1035 L 868.5 1031 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 705.5 1034 L 698.5 1042 L 705.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 873.5 1037 L 877.5 1042 L 873.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 879.5 1044 L 889.5 1055 L 879.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 695.5 1045 L 693.5 1048 L 695.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 691.5 1050 L 690.5 1052 L 691.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 778.5 1050 L 793 1050.5 L 778.5 1051 L 778.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 771.5 1051 L 774 1051.5 L 771.5 1052 L 771.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 797.5 1051 L 800 1051.5 L 797.5 1052 L 797.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 748.5 1060 L 747.5 1062 L 748.5 1060 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 745.5 1062 L 744.5 1064 L 745.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 825.5 1062 L 826.5 1064 L 825.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 897.5 1062 L 906.5 1072 L 897.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 682.5 1064 L 681.5 1066 L 682.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 742.5 1064 L 740.5 1067 L 742.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 829.5 1065 L 831.5 1068 L 829.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 630.5 1067 L 648 1067.5 L 630.5 1068 L 630.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 618.5 1068 L 623 1068.5 L 618.5 1069 L 618.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 655.5 1068 L 660 1068.5 L 655.5 1069 L 655.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 610.5 1069 L 614 1069.5 L 610.5 1070 L 610.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 663.5 1069 L 667 1069.5 L 663.5 1070 L 663.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 736.5 1069 L 734.5 1072 L 736.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 910.5 1074 L 914.5 1079 L 910.5 1074 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 731.5 1075 L 729.5 1078 L 731.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 839.5 1075 L 841.5 1078 L 839.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 843.5 1080 L 844.5 1082 L 843.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 917.5 1080 L 919.5 1083 L 917.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 845.5 1083 L 846.5 1085 L 845.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 922.5 1084 L 924.5 1087 L 922.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 927.5 1088 L 929.5 1091 L 927.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 931.5 1091 L 932.5 1093 L 931.5 1091 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 935.5 1094 L 936.5 1096 L 935.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 536.5 1095 L 535.5 1097 L 536.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 737.5 1097 L 738.5 1099 L 737.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 529.5 1099 L 528.5 1101 L 529.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 740.5 1099 L 741.5 1101 L 740.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 942.5 1099 L 943.5 1101 L 942.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 743.5 1101 L 744.5 1103 L 743.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 945.5 1101 L 946.5 1103 L 945.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 524.5 1102 L 523.5 1104 L 524.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 948.5 1103 L 949.5 1105 L 948.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 747.5 1104 L 748.5 1106 L 747.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 751.5 1107 L 752.5 1109 L 751.5 1107 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 855.5 1107 L 856 1109.5 L 855 1109.5 L 855.5 1107 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 956.5 1108 L 957.5 1110 L 956.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 755.5 1110 L 757.5 1113 L 755.5 1110 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 961.5 1111 L 962.5 1113 L 961.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 856.5 1113 L 857 1117.5 L 856 1117.5 L 856.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 506.5 1114 L 505.5 1116 L 506.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 627.5 1114 L 636 1114.5 L 627.5 1115 L 627.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 642.5 1114 L 651 1114.5 L 642.5 1115 L 642.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 619.5 1115 L 622 1115.5 L 619.5 1116 L 619.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 655.5 1115 L 659 1115.5 L 655.5 1116 L 655.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 761.5 1115 L 766.5 1121 L 761.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 503.5 1116 L 502.5 1118 L 503.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 613.5 1116 L 616 1116.5 L 613.5 1117 L 613.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 499.5 1119 L 498.5 1121 L 499.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 1503.5 1121 L 1544 1121.5 L 1503.5 1122 L 1503.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 495.5 1122 L 493.5 1125 L 495.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 981.5 1122 L 982.5 1124 L 981.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 1478.5 1122 L 1488 1122.5 L 1478.5 1123 L 1478.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 1558.5 1122 L 1568 1122.5 L 1558.5 1123 L 1558.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 1462.5 1123 L 1470 1123.5 L 1462.5 1124 L 1462.5 1123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1576.5 1123 L 1582 1123.5 L 1576.5 1124 L 1576.5 1123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 1450.5 1124 L 1456 1124.5 L 1450.5 1125 L 1450.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 1588.5 1124 L 1594 1124.5 L 1588.5 1125 L 1588.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 856.5 1125 L 857 1130.5 L 856 1130.5 L 856.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 1439.5 1125 L 1444 1125.5 L 1439.5 1126 L 1439.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 1599.5 1125 L 1603 1125.5 L 1599.5 1126 L 1599.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 490.5 1126 L 488.5 1129 L 490.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 1429.5 1126 L 1434 1126.5 L 1429.5 1127 L 1429.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 1608.5 1126 L 1612 1126.5 L 1608.5 1127 L 1608.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 1420.5 1127 L 1425 1127.5 L 1420.5 1128 L 1420.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 1616.5 1127 L 1620 1127.5 L 1616.5 1128 L 1616.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 1412.5 1128 L 1416 1128.5 L 1412.5 1129 L 1412.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 1623.5 1128 L 1627 1128.5 L 1623.5 1129 L 1623.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 1405.5 1129 L 1408 1129.5 L 1405.5 1130 L 1405.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 1630.5 1129 L 1633 1129.5 L 1630.5 1130 L 1630.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 485.5 1130 L 483.5 1133 L 485.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 1397.5 1130 L 1401 1130.5 L 1397.5 1131 L 1397.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 1636.5 1130 L 1639 1130.5 L 1636.5 1131 L 1636.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 905.5 1131 L 906.5 1133 L 905.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 1391.5 1131 L 1394 1131.5 L 1391.5 1132 L 1391.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 1642.5 1131 L 1645 1131.5 L 1642.5 1132 L 1642.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 902.5 1132 L 903 1136.5 L 902 1136.5 L 902.5 1132 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 1384.5 1132 L 1387 1132.5 L 1384.5 1133 L 1384.5 1132 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 908.5 1133 L 909.5 1135 L 908.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 1378.5 1133 L 1381 1133.5 L 1378.5 1134 L 1378.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 780.5 1134 L 785.5 1140 L 780.5 1134 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 855.5 1134 L 856 1136.5 L 855 1136.5 L 855.5 1134 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 1372.5 1134 L 1375 1134.5 L 1372.5 1135 L 1372.5 1134 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 479.5 1135 L 475.5 1140 L 479.5 1135 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 710.5 1135 L 711.5 1137 L 710.5 1135 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 1366.5 1135 L 1369 1135.5 L 1366.5 1136 L 1366.5 1135 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 912.5 1136 L 913.5 1138 L 912.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 1360.5 1136 L 1363 1136.5 L 1360.5 1137 L 1360.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 713.5 1137 L 714.5 1139 L 713.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 1355.5 1137 L 1358 1137.5 L 1355.5 1138 L 1355.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 555.5 1138 L 554.5 1140 L 555.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 915.5 1138 L 916.5 1140 L 915.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 716.5 1139 L 717.5 1141 L 716.5 1139 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 901.5 1140 L 902 1142.5 L 901 1142.5 L 901.5 1140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 918.5 1140 L 919.5 1142 L 918.5 1140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 471.5 1142 L 461.5 1153 L 471.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 720.5 1142 L 721.5 1144 L 720.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 787.5 1142 L 789.5 1145 L 787.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 921.5 1142 L 922.5 1144 L 921.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 1330.5 1142 L 1333 1142.5 L 1330.5 1143 L 1330.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 545.5 1144 L 544.5 1146 L 545.5 1144 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 924.5 1144 L 925.5 1146 L 924.5 1144 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 724.5 1145 L 726.5 1148 L 724.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 542.5 1146 L 541.5 1148 L 542.5 1146 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 791.5 1147 L 793.5 1150 L 791.5 1147 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 539.5 1148 L 538.5 1150 L 539.5 1148 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 932.5 1149 L 933.5 1151 L 932.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 536.5 1150 L 535.5 1152 L 536.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 730.5 1150 L 737.5 1158 L 730.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 533.5 1152 L 532.5 1154 L 533.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 795.5 1152 L 796.5 1154 L 795.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 937.5 1152 L 938.5 1154 L 937.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 1283.5 1153 L 1286 1153.5 L 1283.5 1154 L 1283.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 529.5 1155 L 528.5 1157 L 529.5 1155 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 1076.5 1156 L 1079 1156.5 L 1076.5 1157 L 1076.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 1269.5 1156 L 1272 1156.5 L 1269.5 1157 L 1269.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 847.5 1157 L 846.5 1159 L 847.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 1081.5 1157 L 1084 1157.5 L 1081.5 1158 L 1081.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 1264.5 1157 L 1267 1157.5 L 1264.5 1158 L 1264.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 525.5 1158 L 524.5 1160 L 525.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 1086.5 1158 L 1089 1158.5 L 1086.5 1159 L 1086.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 1258.5 1158 L 1261 1158.5 L 1258.5 1159 L 1258.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 800.5 1159 L 801.5 1161 L 800.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 1092.5 1159 L 1095 1159.5 L 1092.5 1160 L 1092.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 1253.5 1159 L 1256 1159.5 L 1253.5 1160 L 1253.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 1098.5 1160 L 1101 1160.5 L 1098.5 1161 L 1098.5 1160 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 1246.5 1160 L 1249 1160.5 L 1246.5 1161 L 1246.5 1160 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 521.5 1161 L 519.5 1164 L 521.5 1161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 953.5 1161 L 954.5 1163 L 953.5 1161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 1104.5 1161 L 1108 1161.5 L 1104.5 1162 L 1104.5 1161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 1239.5 1161 L 1243 1161.5 L 1239.5 1162 L 1239.5 1161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 742.5 1162 L 749.5 1170 L 742.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 802.5 1162 L 803.5 1164 L 802.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 1111.5 1162 L 1115 1162.5 L 1111.5 1163 L 1111.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 1231.5 1162 L 1235 1162.5 L 1231.5 1163 L 1231.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 843.5 1163 L 842.5 1165 L 843.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 1120.5 1163 L 1124 1163.5 L 1120.5 1164 L 1120.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 1221.5 1163 L 1226 1163.5 L 1221.5 1164 L 1221.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 1130.5 1164 L 1136 1164.5 L 1130.5 1165 L 1130.5 1164 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 1209.5 1164 L 1215 1164.5 L 1209.5 1165 L 1209.5 1164 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 448.5 1165 L 437.5 1177 L 448.5 1165 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 516.5 1165 L 513.5 1169 L 516.5 1165 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 1143.5 1165 L 1153 1165.5 L 1143.5 1166 L 1143.5 1165 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 1191.5 1165 L 1201 1165.5 L 1191.5 1166 L 1191.5 1165 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 841.5 1166 L 830.5 1178 L 841.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 510.5 1170 L 506.5 1175 L 510.5 1170 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 807.5 1170 L 808.5 1172 L 807.5 1170 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 1438.5 1172 Q 1440.8 1171.3 1440 1173.5 L 1438 1174.5 L 1438.5 1172 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 752.5 1173 L 754.5 1176 L 752.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 1429.5 1173 L 1433 1173.5 L 1429.5 1174 L 1429.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 1523.5 1173 L 1528 1173.5 L 1523.5 1174 L 1523.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 1537.5 1173 L 1542 1173.5 L 1537.5 1174 L 1537.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1421.5 1174 L 1425 1174.5 L 1421.5 1175 L 1421.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 1545.5 1174 L 1548 1174.5 L 1545.5 1175 L 1545.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 1413.5 1175 L 1417 1175.5 L 1413.5 1176 L 1413.5 1175 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 1406.5 1176 L 1409 1176.5 L 1406.5 1177 L 1406.5 1176 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 1437.5 1176 L 1436.5 1178 L 1437.5 1176 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 1399.5 1177 L 1402 1177.5 L 1399.5 1178 L 1399.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 1633.5 1177 L 1636 1177.5 L 1633.5 1178 L 1633.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 501.5 1178 L 473.5 1207 L 501.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 756.5 1178 L 757.5 1180 L 756.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 828.5 1178 L 827.5 1180 L 828.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 1392.5 1178 L 1396 1178.5 L 1392.5 1179 L 1392.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 1639.5 1178 L 1642 1178.5 L 1639.5 1179 L 1639.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 1386.5 1179 L 1389 1179.5 L 1386.5 1180 L 1386.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 1644.5 1179 L 1647 1179.5 L 1644.5 1180 L 1644.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 1786.5 1179 L 1787.5 1181 L 1786.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 434.5 1180 L 429.5 1186 L 434.5 1180 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 1380.5 1180 L 1383 1180.5 L 1380.5 1181 L 1380.5 1180 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 1374.5 1181 L 1377 1181.5 L 1374.5 1182 L 1374.5 1181 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 1566.5 1181 L 1567.5 1183 L 1566.5 1181 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 759.5 1182 L 760.5 1184 L 759.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 1369.5 1182 L 1372 1182.5 L 1369.5 1183 L 1369.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 1433.5 1182 L 1432.5 1184 L 1433.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 1497.5 1182 L 1496.5 1184 L 1497.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 1658.5 1182 L 1661 1182.5 L 1658.5 1183 L 1658.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 820.5 1183 L 819.5 1185 L 820.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 886.5 1183 L 885.5 1185 L 886.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 1363.5 1183 L 1366 1183.5 L 1363.5 1184 L 1363.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 815.5 1184 L 818 1185.5 L 816.5 1186 L 815.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 1358.5 1184 L 1361 1184.5 L 1358.5 1185 L 1358.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 1571.5 1184 L 1572.5 1186 L 1571.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 1633.5 1184 L 1634.5 1186 L 1633.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 1795.5 1184 L 1796.5 1186 L 1795.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 761.5 1185 L 762.5 1187 L 761.5 1185 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 1353.5 1185 L 1356 1185.5 L 1353.5 1186 L 1353.5 1185 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 1348.5 1186 L 1351 1186.5 L 1348.5 1187 L 1348.5 1186 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 1491.5 1186 L 1490.5 1188 L 1491.5 1186 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 1430.5 1187 L 1429.5 1189 L 1430.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 1575.5 1187 L 1576.5 1189 L 1575.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 1800.5 1187 L 1801.5 1189 L 1800.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 426.5 1189 L 423.5 1193 L 426.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 882.5 1189 L 881.5 1191 L 882.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 1334.5 1189 L 1337 1189.5 L 1334.5 1190 L 1334.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 1487.5 1189 L 1478.5 1199 L 1487.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 1805.5 1190 L 1806.5 1192 L 1805.5 1190 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 765.5 1191 L 766.5 1193 L 765.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 1580.5 1191 L 1585.5 1197 L 1580.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 880.5 1192 L 879.5 1194 L 880.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 1813.5 1195 L 1814.5 1197 L 1813.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 420.5 1196 L 418.5 1199 L 420.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 877.5 1196 L 874.5 1200 L 877.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 1816.5 1197 L 1817.5 1199 L 1816.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 1296.5 1198 L 1299 1198.5 L 1296.5 1199 L 1296.5 1198 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 1587.5 1199 L 1589.5 1202 L 1587.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 1819.5 1199 L 1820.5 1201 L 1819.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 1287.5 1200 L 1290 1200.5 L 1287.5 1201 L 1287.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 1061.5 1201 L 1064 1201.5 L 1061.5 1202 L 1061.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 1476.5 1201 L 1475.5 1203 L 1476.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 415.5 1202 L 413.5 1205 L 415.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 1066.5 1202 L 1069 1202.5 L 1066.5 1203 L 1066.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 1071.5 1203 L 1074 1203.5 L 1071.5 1204 L 1071.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 1272.5 1203 L 1275 1203.5 L 1272.5 1204 L 1272.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 1590.5 1203 L 1591.5 1205 L 1590.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 870.5 1204 L 868.5 1207 L 870.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 1076.5 1204 L 1079 1204.5 L 1076.5 1205 L 1076.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 1267.5 1204 L 1270 1204.5 L 1267.5 1205 L 1267.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 1474.5 1204 L 1473.5 1206 L 1474.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 1826.5 1204 L 1827.5 1206 L 1826.5 1204 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 1261.5 1205 L 1264 1205.5 L 1261.5 1206 L 1261.5 1205 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 1087.5 1206 L 1091 1206.5 L 1087.5 1207 L 1087.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 1255.5 1206 L 1258 1206.5 L 1255.5 1207 L 1255.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 1592.5 1206 L 1593.5 1208 L 1592.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 1829.5 1206 L 1830.5 1208 L 1829.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 411.5 1207 L 409.5 1210 L 411.5 1207 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 1094.5 1207 L 1097 1207.5 L 1094.5 1208 L 1094.5 1207 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 1248.5 1207 L 1251 1207.5 L 1248.5 1208 L 1248.5 1207 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 1101.5 1208 L 1105 1208.5 L 1101.5 1209 L 1101.5 1208 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_823"
          d="M 1240.5 1208 L 1244 1208.5 L 1240.5 1209 L 1240.5 1208 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_824"
          d="M 1109.5 1209 L 1113 1209.5 L 1109.5 1210 L 1109.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_825"
          d="M 1230.5 1209 L 1235 1209.5 L 1230.5 1210 L 1230.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_826"
          d="M 1471.5 1209 L 1470.5 1211 L 1471.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_827"
          d="M 1833.5 1209 L 1834.5 1211 L 1833.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_828"
          d="M 470.5 1210 L 465.5 1216 L 470.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_829"
          d="M 863.5 1210 L 860.5 1214 L 863.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_830"
          d="M 1118.5 1210 L 1123 1210.5 L 1118.5 1211 L 1118.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_831"
          d="M 1220.5 1210 L 1225 1210.5 L 1220.5 1211 L 1220.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_832"
          d="M 1129.5 1211 L 1136 1211.5 L 1129.5 1212 L 1129.5 1211 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_833"
          d="M 1206.5 1211 L 1213 1211.5 L 1206.5 1212 L 1206.5 1211 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_834"
          d="M 407.5 1212 L 405.5 1215 L 407.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_835"
          d="M 1145.5 1212 L 1161 1212.5 L 1145.5 1213 L 1145.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_836"
          d="M 1181.5 1212 L 1197 1212.5 L 1181.5 1213 L 1181.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_837"
          d="M 1837.5 1212 L 1838.5 1214 L 1837.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_838"
          d="M 857.5 1215 L 856.5 1217 L 857.5 1215 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_839"
          d="M 1841.5 1215 L 1843.5 1218 L 1841.5 1215 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_840"
          d="M 404.5 1216 L 402.5 1219 L 404.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_841"
          d="M 853.5 1218 L 852.5 1220 L 853.5 1218 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_842"
          d="M 1647.5 1218 L 1648 1220.5 L 1647 1220.5 L 1647.5 1218 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_843"
          d="M 462.5 1219 L 459.5 1223 L 462.5 1219 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_844"
          d="M 1846.5 1219 L 1849.5 1223 L 1846.5 1219 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_845"
          d="M 850.5 1220 L 849.5 1222 L 850.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_846"
          d="M 400.5 1221 L 399.5 1223 L 400.5 1221 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_847"
          d="M 845.5 1223 L 844.5 1225 L 845.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_848"
          d="M 1648.5 1223 L 1649 1225.5 L 1648 1225.5 L 1648.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_849"
          d="M 1852.5 1224 L 1856.5 1229 L 1852.5 1224 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_850"
          d="M 397.5 1225 L 396.5 1227 L 397.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_851"
          d="M 456.5 1226 L 453.5 1230 L 456.5 1226 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_852"
          d="M 1774.5 1226 L 1775.5 1228 L 1774.5 1226 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_853"
          d="M 1416.5 1228 L 1417 1231.5 L 1416 1231.5 L 1416.5 1228 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_854"
          d="M 394.5 1229 L 393.5 1231 L 394.5 1229 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_855"
          d="M 1779.5 1229 L 1780.5 1231 L 1779.5 1229 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_856"
          d="M 1463.5 1230 L 1464 1232.5 L 1463 1232.5 L 1463.5 1230 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_857"
          d="M 1649.5 1230 L 1650 1234.5 L 1649 1234.5 L 1649.5 1230 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_858"
          d="M 1602.5 1231 L 1603 1233.5 L 1602 1233.5 L 1602.5 1231 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_859"
          d="M 392.5 1232 L 391.5 1234 L 392.5 1232 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_860"
          d="M 451.5 1232 L 449.5 1235 L 451.5 1232 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_861"
          d="M 1787.5 1234 L 1788.5 1236 L 1787.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_862"
          d="M 1862.5 1234 L 1863.5 1236 L 1862.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_863"
          d="M 389.5 1236 L 388.5 1238 L 389.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_864"
          d="M 1462.5 1236 L 1463 1247.5 L 1462 1247.5 L 1462.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_865"
          d="M 1790.5 1236 L 1791.5 1238 L 1790.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_866"
          d="M 447.5 1237 L 445.5 1240 L 447.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_867"
          d="M 1793.5 1238 L 1794.5 1240 L 1793.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_868"
          d="M 1603.5 1239 L 1604 1248.5 L 1603 1248.5 L 1603.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_869"
          d="M 1415.5 1240 L 1416 1245.5 L 1415 1245.5 L 1415.5 1240 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_870"
          d="M 1796.5 1240 L 1797.5 1242 L 1796.5 1240 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_871"
          d="M 443.5 1242 L 442.5 1244 L 443.5 1242 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_872"
          d="M 1866.5 1242 L 1867 1244.5 L 1866 1244.5 L 1866.5 1242 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_873"
          d="M 384.5 1243 L 383.5 1245 L 384.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_874"
          d="M 1800.5 1243 L 1801.5 1245 L 1800.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_875"
          d="M 836.5 1245 L 837 1247.5 L 836 1247.5 L 836.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_876"
          d="M 1803.5 1245 L 1804.5 1247 L 1803.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_877"
          d="M 382.5 1246 L 381.5 1248 L 382.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_878"
          d="M 440.5 1246 L 439.5 1248 L 440.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_879"
          d="M 789.5 1248 L 790 1250.5 L 789 1250.5 L 789.5 1248 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_880"
          d="M 1807.5 1248 L 1808.5 1250 L 1807.5 1248 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_881"
          d="M 380.5 1249 L 379.5 1251 L 380.5 1249 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_882"
          d="M 437.5 1250 L 436.5 1252 L 437.5 1250 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_883"
          d="M 837.5 1251 L 838 1254.5 L 837 1254.5 L 837.5 1251 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_884"
          d="M 1811.5 1251 L 1813.5 1254 L 1811.5 1251 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_885"
          d="M 1866.5 1251 L 1867 1253.5 L 1866 1253.5 L 1866.5 1251 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_886"
          d="M 1463.5 1252 L 1464 1255.5 L 1463 1255.5 L 1463.5 1252 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_887"
          d="M 790.5 1253 L 791 1255.5 L 790 1255.5 L 790.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_888"
          d="M 1495.5 1253 L 1511 1253.5 L 1495.5 1254 L 1495.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_889"
          d="M 1602.5 1253 L 1603 1255.5 L 1602 1255.5 L 1602.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_890"
          d="M 1649.5 1253 L 1650 1257.5 L 1649 1257.5 L 1649.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_891"
          d="M 434.5 1254 L 433.5 1256 L 434.5 1254 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_892"
          d="M 1480.5 1254 L 1486 1254.5 L 1480.5 1255 L 1480.5 1254 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_893"
          d="M 1520.5 1254 L 1525 1254.5 L 1520.5 1255 L 1520.5 1254 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_894"
          d="M 1416.5 1255 L 1417 1258.5 L 1416 1258.5 L 1416.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_895"
          d="M 1472.5 1255 L 1476 1255.5 L 1472.5 1256 L 1472.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_896"
          d="M 1530.5 1255 L 1534 1255.5 L 1530.5 1256 L 1530.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_897"
          d="M 1816.5 1255 L 1819.5 1259 L 1816.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_898"
          d="M 1466.5 1256 L 1469 1256.5 L 1466.5 1257 L 1466.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_899"
          d="M 1537.5 1256 L 1540 1256.5 L 1537.5 1257 L 1537.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_900"
          d="M 1543.5 1257 L 1546 1257.5 L 1543.5 1258 L 1543.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_901"
          d="M 431.5 1258 L 430.5 1260 L 431.5 1258 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_902"
          d="M 1548.5 1258 L 1551 1258.5 L 1548.5 1259 L 1548.5 1258 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_903"
          d="M 838.5 1259 L 839 1263.5 L 838 1263.5 L 838.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_904"
          d="M 791.5 1260 L 792 1263.5 L 791 1263.5 L 791.5 1260 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_905"
          d="M 1822.5 1260 L 1826.5 1265 L 1822.5 1260 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_906"
          d="M 372.5 1261 L 371.5 1263 L 372.5 1261 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_907"
          d="M 1417.5 1262 L 1418 1264.5 L 1417 1264.5 L 1417.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_908"
          d="M 1648.5 1262 L 1649 1264.5 L 1648 1264.5 L 1648.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_909"
          d="M 1861.5 1263 L 1859.5 1266 L 1861.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_910"
          d="M 370.5 1264 L 369.5 1266 L 370.5 1264 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_911"
          d="M 426.5 1265 L 425.5 1267 L 426.5 1265 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_912"
          d="M 1829.5 1266 L 1830.5 1268 L 1829.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_913"
          d="M 1647.5 1267 L 1648 1269.5 L 1647 1269.5 L 1647.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_914"
          d="M 1856.5 1267 L 1855.5 1269 L 1856.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_915"
          d="M 424.5 1268 L 423.5 1270 L 424.5 1268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_916"
          d="M 1832.5 1268 L 1835 1269.5 L 1833.5 1270 L 1832.5 1268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_917"
          d="M 792.5 1269 L 793 1291.5 L 792 1291.5 L 792.5 1269 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_918"
          d="M 1840.5 1271 L 1847 1271.5 L 1840.5 1272 L 1840.5 1271 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_919"
          d="M 365.5 1272 L 364.5 1274 L 365.5 1272 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_920"
          d="M 839.5 1273 L 840 1288.5 L 839 1288.5 L 839.5 1273 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_921"
          d="M 417.5 1278 L 416.5 1280 L 417.5 1278 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_922"
          d="M 1406.5 1278 L 1405.5 1280 L 1406.5 1278 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_923"
          d="M 360.5 1280 L 359.5 1282 L 360.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_924"
          d="M 1398.5 1283 L 1397.5 1285 L 1398.5 1283 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_925"
          d="M 1395.5 1285 L 1394.5 1287 L 1395.5 1285 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_926"
          d="M 1391.5 1288 L 1390.5 1290 L 1391.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_927"
          d="M 1387.5 1291 L 1386.5 1293 L 1387.5 1291 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_928"
          d="M 353.5 1292 L 352.5 1294 L 353.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_929"
          d="M 408.5 1292 L 407.5 1294 L 408.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_930"
          d="M 1383.5 1294 L 1379.5 1299 L 1383.5 1294 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_931"
          d="M 791.5 1297 L 792 1300.5 L 791 1300.5 L 791.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_932"
          d="M 838.5 1297 L 839 1301.5 L 838 1301.5 L 838.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_933"
          d="M 1638.5 1298 L 1640.5 1301 L 1638.5 1298 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_934"
          d="M 1489.5 1300 L 1500 1300.5 L 1489.5 1301 L 1489.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_935"
          d="M 1504.5 1300 L 1515 1300.5 L 1504.5 1301 L 1504.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_936"
          d="M 1480.5 1301 L 1484 1301.5 L 1480.5 1302 L 1480.5 1301 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_937"
          d="M 1521.5 1301 L 1525 1301.5 L 1521.5 1302 L 1521.5 1301 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_938"
          d="M 1374.5 1302 L 1367.5 1310 L 1374.5 1302 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_939"
          d="M 1474.5 1302 L 1477 1302.5 L 1474.5 1303 L 1474.5 1302 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_940"
          d="M 1529.5 1302 L 1532 1302.5 L 1529.5 1303 L 1529.5 1302 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_941"
          d="M 1643.5 1302 L 1645.5 1305 L 1643.5 1302 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_942"
          d="M 1535.5 1303 L 1538 1303.5 L 1535.5 1304 L 1535.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_943"
          d="M 790.5 1305 L 791 1307.5 L 790 1307.5 L 790.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_944"
          d="M 837.5 1307 L 838 1309.5 L 837 1309.5 L 837.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_945"
          d="M 1649.5 1307 L 1668.5 1327 L 1649.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_946"
          d="M 789.5 1310 L 790 1312.5 L 789 1312.5 L 789.5 1310 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_947"
          d="M 342.5 1312 L 341.5 1314 L 342.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_948"
          d="M 836.5 1313 L 837 1315.5 L 836 1315.5 L 836.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_949"
          d="M 1363.5 1314 L 1359.5 1319 L 1363.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_950"
          d="M 392.5 1319 L 391.5 1321 L 392.5 1319 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_951"
          d="M 835.5 1319 L 836 1321.5 L 835 1321.5 L 835.5 1319 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_952"
          d="M 1357.5 1321 L 1355.5 1324 L 1357.5 1321 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_953"
          d="M 1421.5 1324 L 1420.5 1326 L 1421.5 1324 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_954"
          d="M 1593.5 1324 L 1594.5 1326 L 1593.5 1324 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_955"
          d="M 1353.5 1326 L 1352.5 1328 L 1353.5 1326 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_956"
          d="M 1418.5 1326 L 1416.5 1329 L 1418.5 1326 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_957"
          d="M 1601.5 1329 L 1602.5 1331 L 1601.5 1329 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_958"
          d="M 1670.5 1329 L 1673.5 1333 L 1670.5 1329 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_959"
          d="M 386.5 1330 L 385.5 1332 L 386.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_960"
          d="M 1350.5 1330 L 1349.5 1332 L 1350.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_961"
          d="M 1413.5 1330 L 1409.5 1335 L 1413.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_962"
          d="M 1604.5 1331 L 1605.5 1333 L 1604.5 1331 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_963"
          d="M 1348.5 1333 L 1347.5 1335 L 1348.5 1333 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_964"
          d="M 1608.5 1334 L 1609.5 1336 L 1608.5 1334 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_965"
          d="M 1675.5 1335 L 1676.5 1337 L 1675.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_966"
          d="M 1346.5 1336 L 1345.5 1338 L 1346.5 1336 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_967"
          d="M 1612.5 1337 L 1614.5 1340 L 1612.5 1337 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_968"
          d="M 1344.5 1339 L 1343.5 1341 L 1344.5 1339 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_969"
          d="M 1678.5 1339 L 1679.5 1341 L 1678.5 1339 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_970"
          d="M 1618.5 1342 L 1632.5 1357 L 1618.5 1342 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_971"
          d="M 1680.5 1342 L 1681.5 1344 L 1680.5 1342 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_972"
          d="M 1400.5 1343 L 1395.5 1349 L 1400.5 1343 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_973"
          d="M 1338.5 1349 L 1337.5 1351 L 1338.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_974"
          d="M 1393.5 1351 L 1392.5 1353 L 1393.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_975"
          d="M 1390.5 1355 L 1389.5 1357 L 1390.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_976"
          d="M 1387.5 1359 L 1386.5 1361 L 1387.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_977"
          d="M 1634.5 1359 L 1637.5 1363 L 1634.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_978"
          d="M 1385.5 1362 L 1384.5 1364 L 1385.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_979"
          d="M 769.5 1364 L 768.5 1366 L 769.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_980"
          d="M 1639.5 1365 L 1640.5 1367 L 1639.5 1365 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_981"
          d="M 1379.5 1372 L 1378.5 1374 L 1379.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_982"
          d="M 763.5 1374 L 762.5 1376 L 763.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_983"
          d="M 761.5 1377 L 760.5 1379 L 761.5 1377 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_984"
          d="M 1647.5 1377 L 1648.5 1379 L 1647.5 1377 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_985"
          d="M 759.5 1380 L 758.5 1382 L 759.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_986"
          d="M 757.5 1383 L 756.5 1385 L 757.5 1383 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_987"
          d="M 754.5 1387 L 753.5 1389 L 754.5 1387 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_988"
          d="M 751.5 1391 L 749.5 1394 L 751.5 1391 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_989"
          d="M 807.5 1392 L 806.5 1394 L 807.5 1392 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_990"
          d="M 747.5 1396 L 745.5 1399 L 747.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_991"
          d="M 802.5 1400 L 801.5 1402 L 802.5 1400 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_992"
          d="M 743.5 1401 L 739.5 1406 L 743.5 1401 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_993"
          d="M 800.5 1403 L 799.5 1405 L 800.5 1403 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_994"
          d="M 798.5 1406 L 797.5 1408 L 798.5 1406 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_995"
          d="M 796.5 1409 L 795.5 1411 L 796.5 1409 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_996"
          d="M 735.5 1410 L 718.5 1428 L 735.5 1410 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_997"
          d="M 793.5 1413 L 792.5 1415 L 793.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_998"
          d="M 790.5 1417 L 789.5 1419 L 790.5 1417 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_999"
          d="M 1714.5 1419 L 1715 1421.5 L 1714 1421.5 L 1714.5 1419 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1000"
          d="M 787.5 1421 L 786.5 1423 L 787.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1001"
          d="M 1715.5 1424 L 1716 1426.5 L 1715 1426.5 L 1715.5 1424 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1002"
          d="M 784.5 1425 L 781.5 1429 L 784.5 1425 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1003"
          d="M 299.5 1426 L 300 1428.5 L 299 1428.5 L 299.5 1426 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1004"
          d="M 1716.5 1429 L 1717 1431.5 L 1716 1431.5 L 1716.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1005"
          d="M 346.5 1431 L 347 1433.5 L 346 1433.5 L 346.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1006"
          d="M 713.5 1431 L 709.5 1436 L 713.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1007"
          d="M 779.5 1431 L 775.5 1436 L 779.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1008"
          d="M 298.5 1432 L 299 1434.5 L 298 1434.5 L 298.5 1432 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1009"
          d="M 1717.5 1435 L 1718 1438.5 L 1717 1438.5 L 1717.5 1435 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1010"
          d="M 297.5 1438 L 298 1440.5 L 297 1440.5 L 297.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1011"
          d="M 705.5 1438 L 703.5 1441 L 705.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1012"
          d="M 1670.5 1438 L 1671 1440.5 L 1670 1440.5 L 1670.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1013"
          d="M 772.5 1439 L 747.5 1465 L 772.5 1439 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1014"
          d="M 344.5 1441 L 345 1443.5 L 344 1443.5 L 344.5 1441 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1015"
          d="M 1305.5 1442 L 1306 1444.5 L 1305 1444.5 L 1305.5 1442 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1016"
          d="M 1718.5 1442 L 1719 1445.5 L 1718 1445.5 L 1718.5 1442 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1017"
          d="M 699.5 1443 L 697.5 1446 L 699.5 1443 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1018"
          d="M 1671.5 1444 L 1672 1446.5 L 1671 1446.5 L 1671.5 1444 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1019"
          d="M 296.5 1445 L 297 1448.5 L 296 1448.5 L 296.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1020"
          d="M 343.5 1447 L 344 1449.5 L 343 1449.5 L 343.5 1447 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1021"
          d="M 694.5 1447 L 693.5 1449 L 694.5 1447 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1022"
          d="M 1304.5 1447 L 1305 1449.5 L 1304 1449.5 L 1304.5 1447 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1023"
          d="M 690.5 1450 L 689.5 1452 L 690.5 1450 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1024"
          d="M 1351.5 1450 L 1352 1452.5 L 1351 1452.5 L 1351.5 1450 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1025"
          d="M 1672.5 1451 L 1673 1455.5 L 1672 1455.5 L 1672.5 1451 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1026"
          d="M 1719.5 1451 L 1720 1457.5 L 1719 1457.5 L 1719.5 1451 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1027"
          d="M 686.5 1453 L 685.5 1455 L 686.5 1453 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1028"
          d="M 1303.5 1453 L 1304 1456.5 L 1303 1456.5 L 1303.5 1453 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1029"
          d="M 295.5 1454 L 296 1460.5 L 295 1460.5 L 295.5 1454 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1030"
          d="M 342.5 1454 L 343 1458.5 L 342 1458.5 L 342.5 1454 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1031"
          d="M 682.5 1456 L 681.5 1458 L 682.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1032"
          d="M 1350.5 1456 L 1351 1458.5 L 1350 1458.5 L 1350.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1033"
          d="M 1302.5 1460 L 1303 1462.5 L 1302 1462.5 L 1302.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1034"
          d="M 675.5 1461 L 674.5 1463 L 675.5 1461 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1035"
          d="M 1349.5 1462 L 1350 1464.5 L 1349 1464.5 L 1349.5 1462 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1036"
          d="M 1673.5 1462 L 1674 1476.5 L 1673 1476.5 L 1673.5 1462 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1037"
          d="M 672.5 1463 L 671.5 1465 L 672.5 1463 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1038"
          d="M 669.5 1465 L 668.5 1467 L 669.5 1465 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1039"
          d="M 341.5 1467 L 342 1477.5 L 341 1477.5 L 341.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1040"
          d="M 666.5 1467 L 665.5 1469 L 666.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1041"
          d="M 743.5 1467 L 739.5 1472 L 743.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1042"
          d="M 1301.5 1467 L 1302 1470.5 L 1301 1470.5 L 1301.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1043"
          d="M 1720.5 1467 L 1721 1489.5 L 1720 1489.5 L 1720.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1044"
          d="M 1348.5 1468 L 1349 1471.5 L 1348 1471.5 L 1348.5 1468 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1045"
          d="M 663.5 1469 L 662.5 1471 L 663.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1046"
          d="M 660.5 1471 L 659.5 1473 L 660.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1047"
          d="M 735.5 1474 L 733.5 1477 L 735.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1048"
          d="M 652.5 1476 L 651.5 1478 L 652.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1049"
          d="M 1300.5 1476 L 1301 1479.5 L 1300 1479.5 L 1300.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1050"
          d="M 1347.5 1476 L 1348 1479.5 L 1347 1479.5 L 1347.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1051"
          d="M 730.5 1478 L 727.5 1482 L 730.5 1478 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1052"
          d="M 647.5 1479 L 646.5 1481 L 647.5 1479 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1053"
          d="M 1673.5 1480 L 1674 1493.5 L 1673 1493.5 L 1673.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1054"
          d="M 642.5 1482 L 641.5 1484 L 642.5 1482 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1055"
          d="M 295.5 1483 L 296 1488.5 L 295 1488.5 L 295.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1056"
          d="M 724.5 1483 L 723.5 1485 L 724.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1057"
          d="M 342.5 1485 L 343 1488.5 L 342 1488.5 L 342.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1058"
          d="M 1299.5 1485 L 1300 1490.5 L 1299 1490.5 L 1299.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1059"
          d="M 1346.5 1485 L 1347 1489.5 L 1346 1489.5 L 1346.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1060"
          d="M 635.5 1486 L 634.5 1488 L 635.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1061"
          d="M 720.5 1486 L 719.5 1488 L 720.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1062"
          d="M 716.5 1489 L 715.5 1491 L 716.5 1489 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1063"
          d="M 626.5 1491 L 625.5 1493 L 626.5 1491 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1064"
          d="M 712.5 1492 L 711.5 1494 L 712.5 1492 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1065"
          d="M 296.5 1493 L 297 1496.5 L 296 1496.5 L 296.5 1493 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1066"
          d="M 708.5 1495 L 707.5 1497 L 708.5 1495 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1067"
          d="M 1345.5 1495 L 1346 1501.5 L 1345 1501.5 L 1345.5 1495 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1068"
          d="M 705.5 1497 L 704.5 1499 L 705.5 1497 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1069"
          d="M 1298.5 1498 L 1299 1504.5 L 1298 1504.5 L 1298.5 1498 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1070"
          d="M 297.5 1500 L 298 1502.5 L 297 1502.5 L 297.5 1500 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1071"
          d="M 1719.5 1500 L 1720 1505.5 L 1719 1505.5 L 1719.5 1500 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1072"
          d="M 1672.5 1501 L 1673 1506.5 L 1672 1506.5 L 1672.5 1501 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1073"
          d="M 698.5 1502 L 697.5 1504 L 698.5 1502 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1074"
          d="M 695.5 1504 L 694.5 1506 L 695.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1075"
          d="M 692.5 1506 L 691.5 1508 L 692.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1076"
          d="M 1344.5 1510 L 1345 1521.5 L 1344 1521.5 L 1344.5 1510 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1077"
          d="M 1671.5 1511 L 1672 1514.5 L 1671 1514.5 L 1671.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1078"
          d="M 1718.5 1512 L 1719 1515.5 L 1718 1515.5 L 1718.5 1512 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1079"
          d="M 681.5 1513 L 680.5 1515 L 681.5 1513 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1080"
          d="M 351.5 1515 L 352.5 1517 L 351.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1081"
          d="M 1297.5 1516 L 1298 1536.5 L 1297 1536.5 L 1297.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1082"
          d="M 353.5 1518 L 354.5 1520 L 353.5 1518 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1083"
          d="M 1670.5 1519 L 1671 1522.5 L 1670 1522.5 L 1670.5 1519 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1084"
          d="M 1717.5 1520 L 1718 1523.5 L 1717 1523.5 L 1717.5 1520 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1085"
          d="M 355.5 1521 L 364.5 1531 L 355.5 1521 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1086"
          d="M 661.5 1525 L 660.5 1527 L 661.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1087"
          d="M 1669.5 1526 L 1670 1528.5 L 1669 1528.5 L 1669.5 1526 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1088"
          d="M 1716.5 1528 L 1717 1530.5 L 1716 1530.5 L 1716.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1089"
          d="M 652.5 1530 L 651.5 1532 L 652.5 1530 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1090"
          d="M 367.5 1532 L 368.5 1534 L 367.5 1532 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1091"
          d="M 1715.5 1534 L 1716 1536.5 L 1715 1536.5 L 1715.5 1534 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1092"
          d="M 372.5 1535 L 373.5 1537 L 372.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1093"
          d="M 309.5 1536 L 310.5 1538 L 309.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1094"
          d="M 1714.5 1540 L 1715 1542.5 L 1714 1542.5 L 1714.5 1540 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1095"
          d="M 312.5 1541 L 313.5 1543 L 312.5 1541 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1096"
          d="M 495.5 1541 L 498 1541.5 L 495.5 1542 L 495.5 1541 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1097"
          d="M 314.5 1544 L 315.5 1546 L 314.5 1544 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1098"
          d="M 480.5 1544 L 483 1544.5 L 480.5 1545 L 480.5 1544 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1099"
          d="M 474.5 1545 L 477 1545.5 L 474.5 1546 L 474.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1100"
          d="M 1297.5 1545 L 1298 1567.5 L 1297 1567.5 L 1297.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1101"
          d="M 1713.5 1545 L 1714 1547.5 L 1713 1547.5 L 1713.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1102"
          d="M 403.5 1546 L 406 1546.5 L 403.5 1547 L 403.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1103"
          d="M 467.5 1546 L 471 1546.5 L 467.5 1547 L 467.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1104"
          d="M 1665.5 1546 L 1666 1548.5 L 1665 1548.5 L 1665.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1105"
          d="M 316.5 1547 L 317.5 1549 L 316.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1106"
          d="M 409.5 1547 L 413 1547.5 L 409.5 1548 L 409.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1107"
          d="M 458.5 1547 L 463 1547.5 L 458.5 1548 L 458.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1108"
          d="M 418.5 1548 L 426 1548.5 L 418.5 1549 L 418.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1109"
          d="M 444.5 1548 L 452 1548.5 L 444.5 1549 L 444.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1110"
          d="M 1712.5 1550 L 1713 1552.5 L 1712 1552.5 L 1712.5 1550 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1111"
          d="M 319.5 1551 L 323.5 1556 L 319.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1112"
          d="M 1344.5 1558 L 1345 1569.5 L 1344 1569.5 L 1344.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1113"
          d="M 331.5 1563 L 334.5 1567 L 331.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1114"
          d="M 337.5 1568 L 338.5 1570 L 337.5 1568 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1115"
          d="M 1298.5 1578 L 1299 1585.5 L 1298 1585.5 L 1298.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1116"
          d="M 1345.5 1579 L 1346 1585.5 L 1345 1585.5 L 1345.5 1579 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1117"
          d="M 497.5 1588 L 500 1588.5 L 497.5 1589 L 497.5 1588 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1118"
          d="M 492.5 1589 L 495 1589.5 L 492.5 1590 L 492.5 1589 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1119"
          d="M 384.5 1590 L 387 1590.5 L 384.5 1591 L 384.5 1590 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1120"
          d="M 486.5 1590 L 489 1590.5 L 486.5 1591 L 486.5 1590 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1121"
          d="M 480.5 1591 L 483 1591.5 L 480.5 1592 L 480.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1122"
          d="M 394.5 1592 L 397 1592.5 L 394.5 1593 L 394.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1123"
          d="M 473.5 1592 L 477 1592.5 L 473.5 1593 L 473.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1124"
          d="M 1346.5 1592 L 1347 1597.5 L 1346 1597.5 L 1346.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1125"
          d="M 400.5 1593 L 403 1593.5 L 400.5 1594 L 400.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1126"
          d="M 465.5 1593 L 469 1593.5 L 465.5 1594 L 465.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1127"
          d="M 1299.5 1593 L 1300 1598.5 L 1299 1598.5 L 1299.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1128"
          d="M 408.5 1594 L 413 1594.5 L 408.5 1595 L 408.5 1594 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1129"
          d="M 454.5 1594 L 460 1594.5 L 454.5 1595 L 454.5 1594 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1130"
          d="M 420.5 1595 L 446 1595.5 L 420.5 1596 L 420.5 1595 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1131"
          d="M 1347.5 1603 L 1348 1607.5 L 1347 1607.5 L 1347.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1132"
          d="M 1300.5 1605 L 1301 1609.5 L 1300 1609.5 L 1300.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1133"
          d="M 1348.5 1612 L 1349 1615.5 L 1348 1615.5 L 1348.5 1612 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1134"
          d="M 1301.5 1615 L 1302 1618.5 L 1301 1618.5 L 1301.5 1615 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1135"
          d="M 1349.5 1620 L 1350 1623.5 L 1349 1623.5 L 1349.5 1620 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1136"
          d="M 1302.5 1623 L 1303 1626.5 L 1302 1626.5 L 1302.5 1623 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1137"
          d="M 1350.5 1627 L 1351 1630.5 L 1350 1630.5 L 1350.5 1627 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1138"
          d="M 1303.5 1631 L 1304 1634.5 L 1303 1634.5 L 1303.5 1631 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1139"
          d="M 1351.5 1634 L 1352 1636.5 L 1351 1636.5 L 1351.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1140"
          d="M 1304.5 1638 L 1305 1640.5 L 1304 1640.5 L 1304.5 1638 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1141"
          d="M 1352.5 1640 L 1353 1642.5 L 1352 1642.5 L 1352.5 1640 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1142"
          d="M 1305.5 1645 L 1306 1647.5 L 1305 1647.5 L 1305.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1143"
          d="M 1353.5 1646 L 1354 1648.5 L 1353 1648.5 L 1353.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1144"
          d="M 1306.5 1651 L 1307 1653.5 L 1306 1653.5 L 1306.5 1651 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1145"
          d="M 1354.5 1651 L 1355 1653.5 L 1354 1653.5 L 1354.5 1651 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1146"
          d="M 1308.5 1662 L 1309 1664.5 L 1308 1664.5 L 1308.5 1662 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1147"
          d="M 1357.5 1666 L 1358 1668.5 L 1357 1668.5 L 1357.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1148"
          d="M 1309.5 1667 L 1310 1669.5 L 1309 1669.5 L 1309.5 1667 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1149"
          d="M 1619.5 1670 L 1618.5 1672 L 1619.5 1670 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1150"
          d="M 1310.5 1672 L 1311 1674.5 L 1310 1674.5 L 1310.5 1672 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1151"
          d="M 1312.5 1681 L 1313 1683.5 L 1312 1683.5 L 1312.5 1681 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1152"
          d="M 1664.5 1685 L 1663.5 1687 L 1664.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1153"
          d="M 1605.5 1695 L 1604.5 1697 L 1605.5 1695 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1154"
          d="M 1602.5 1700 L 1601.5 1702 L 1602.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1155"
          d="M 1655.5 1702 L 1654.5 1704 L 1655.5 1702 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1156"
          d="M 1597.5 1708 L 1596.5 1710 L 1597.5 1708 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1157"
          d="M 1595.5 1711 L 1594.5 1713 L 1595.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1158"
          d="M 1593.5 1714 L 1592.5 1716 L 1593.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1159"
          d="M 1647.5 1716 L 1646.5 1718 L 1647.5 1716 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1160"
          d="M 1591.5 1717 L 1590.5 1719 L 1591.5 1717 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1161"
          d="M 1589.5 1720 L 1588.5 1722 L 1589.5 1720 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1162"
          d="M 1644.5 1721 L 1643.5 1723 L 1644.5 1721 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1163"
          d="M 1587.5 1723 L 1586.5 1725 L 1587.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1164"
          d="M 1641.5 1726 L 1640.5 1728 L 1641.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1165"
          d="M 1582.5 1730 L 1581.5 1732 L 1582.5 1730 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1166"
          d="M 1579.5 1734 L 1578.5 1736 L 1579.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1167"
          d="M 1634.5 1737 L 1633.5 1739 L 1634.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1168"
          d="M 1576.5 1738 L 1575.5 1740 L 1576.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1169"
          d="M 1632.5 1740 L 1631.5 1742 L 1632.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1170"
          d="M 1573.5 1742 L 1572.5 1744 L 1573.5 1742 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1171"
          d="M 1630.5 1743 L 1629.5 1745 L 1630.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1172"
          d="M 1570.5 1746 L 1568.5 1749 L 1570.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1173"
          d="M 1628.5 1746 L 1627.5 1748 L 1628.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1174"
          d="M 1626.5 1749 L 1625.5 1751 L 1626.5 1749 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1175"
          d="M 1565.5 1752 L 1563.5 1755 L 1565.5 1752 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1176"
          d="M 1621.5 1756 L 1620.5 1758 L 1621.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1177"
          d="M 1560.5 1758 L 1555.5 1764 L 1560.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1178"
          d="M 1618.5 1760 L 1617.5 1762 L 1618.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1179"
          d="M 1616.5 1763 L 1614.5 1766 L 1616.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1180"
          d="M 1552.5 1767 L 1538.5 1782 L 1552.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1181"
          d="M 1613.5 1767 L 1611.5 1770 L 1613.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1182"
          d="M 1393.5 1768 L 1394.5 1770 L 1393.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1183"
          d="M 1609.5 1772 L 1608.5 1774 L 1609.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1184"
          d="M 1396.5 1773 L 1397.5 1775 L 1396.5 1773 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1185"
          d="M 1606.5 1776 L 1604.5 1779 L 1606.5 1776 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1186"
          d="M 1602.5 1781 L 1599.5 1785 L 1602.5 1781 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1187"
          d="M 1347.5 1782 L 1348.5 1784 L 1347.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1188"
          d="M 1534.5 1784 L 1530.5 1789 L 1534.5 1784 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1189"
          d="M 1404.5 1785 L 1405.5 1787 L 1404.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1190"
          d="M 1596.5 1788 L 1592.5 1793 L 1596.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1191"
          d="M 1407.5 1789 L 1410.5 1793 L 1407.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1192"
          d="M 1352.5 1791 L 1353.5 1793 L 1352.5 1791 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1193"
          d="M 1526.5 1791 L 1524.5 1794 L 1526.5 1791 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1194"
          d="M 1412.5 1795 L 1420.5 1804 L 1412.5 1795 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1195"
          d="M 1521.5 1795 L 1520.5 1797 L 1521.5 1795 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1196"
          d="M 1355.5 1796 L 1356.5 1798 L 1355.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1197"
          d="M 1589.5 1796 L 1566.5 1820 L 1589.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1198"
          d="M 1517.5 1798 L 1516.5 1800 L 1517.5 1798 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1199"
          d="M 1514.5 1800 L 1513.5 1802 L 1514.5 1800 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1200"
          d="M 1511.5 1802 L 1510.5 1804 L 1511.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1201"
          d="M 1508.5 1804 L 1507.5 1806 L 1508.5 1804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1202"
          d="M 1423.5 1805 L 1425.5 1808 L 1423.5 1805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1203"
          d="M 1363.5 1808 L 1364.5 1810 L 1363.5 1808 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1204"
          d="M 1501.5 1808 L 1500.5 1810 L 1501.5 1808 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1205"
          d="M 1428.5 1809 L 1429.5 1811 L 1428.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1206"
          d="M 1365.5 1811 L 1366.5 1813 L 1365.5 1811 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1207"
          d="M 1368.5 1815 L 1369.5 1817 L 1368.5 1815 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1208"
          d="M 1371.5 1819 L 1374.5 1823 L 1371.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1209"
          d="M 1471.5 1819 L 1474 1819.5 L 1471.5 1820 L 1471.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1210"
          d="M 1455.5 1820 L 1468 1820.5 L 1455.5 1821 L 1455.5 1820 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1211"
          d="M 1562.5 1822 L 1559.5 1826 L 1562.5 1822 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1212"
          d="M 1377.5 1826 L 1390.5 1840 L 1377.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1213"
          d="M 1556.5 1827 L 1554.5 1830 L 1556.5 1827 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1214"
          d="M 1551.5 1831 L 1549.5 1834 L 1551.5 1831 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1215"
          d="M 1546.5 1835 L 1545.5 1837 L 1546.5 1835 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1216"
          d="M 1543.5 1837 L 1542.5 1839 L 1543.5 1837 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1217"
          d="M 1393.5 1841 L 1395.5 1844 L 1393.5 1841 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1218"
          d="M 1534.5 1843 L 1533.5 1845 L 1534.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1219"
          d="M 1398.5 1845 L 1399.5 1847 L 1398.5 1845 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1220"
          d="M 1412.5 1854 L 1413.5 1856 L 1412.5 1854 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1221"
          d="M 1485.5 1864 L 1488 1864.5 L 1485.5 1865 L 1485.5 1864 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1222"
          d="M 1441.5 1865 L 1444 1865.5 L 1441.5 1866 L 1441.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1223"
          d="M 1480.5 1865 L 1483 1865.5 L 1480.5 1866 L 1480.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1224"
          d="M 1447.5 1866 L 1451 1866.5 L 1447.5 1867 L 1447.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1225"
          d="M 1473.5 1866 L 1477 1866.5 L 1473.5 1867 L 1473.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1226"
          d="M 1458.5 1867 L 1465 1867.5 L 1458.5 1868 L 1458.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1227"
          d="M 19.5 1 L 113.5 1 L 114.5 2 L 149.5 2 L 150.5 3 L 174.5 3 L 175.5 4 L 209.5 5 L 210.5 6 L 236.5 7 L 237.5 8 L 247.5 8 L 248.5 9 L 257.5 9 L 258.5 10 L 291.5 13 L 343.5 22 L 372.5 29 L 407.5 40 L 448.5 58 Q 488.3 79.2 518 110.5 Q 536.2 129.8 551 152.5 Q 569.2 180.8 583 213.5 L 598 252.5 L 607 280.5 L 640 401.5 L 660 458.5 L 678 500.5 Q 694.3 535.7 714 567.5 Q 729.9 594.1 749.5 617 Q 786.6 473.1 877.5 383 Q 935.7 328.7 1016.5 297 L 1058.5 283 L 1101.5 273 L 1119.5 271 L 1120.5 270 L 1127.5 270 L 1128.5 269 L 1136.5 269 L 1137.5 268 L 1147.5 268 L 1148.5 267 L 1186.5 266 L 1187.5 267 L 1213.5 268 L 1242.5 273 L 1268.5 280 L 1297.5 291 Q 1358.7 318.8 1400 366.5 Q 1434 404.5 1454 456.5 L 1461 477.5 L 1469 513.5 L 1470 528.5 L 1471 529.5 L 1471 540.5 L 1472 541.5 L 1472 577.5 L 1471 578.5 L 1471 589.5 L 1470 590.5 L 1469 605.5 L 1462 637.5 Q 1454.5 664.5 1443 687.5 Q 1419 734.5 1382.5 769 Q 1338.5 811.5 1275.5 835 L 1237.5 846 L 1209.5 851 L 1190.5 852 L 1189.5 853 L 1139.5 853 L 1138.5 852 L 1122.5 852 L 1121.5 851 L 1089.5 849 L 1088.5 848 L 1073.5 847 L 1072.5 846 L 1066.5 846 L 1042.5 841 L 1037.5 841 L 990.5 830 L 941.5 814 Q 847.5 778 779.5 716 L 779 726.5 L 778 727.5 L 778 754.5 L 777 755.5 L 777 763.5 L 778 764.5 L 778 790.5 L 779 791.5 L 780 812.5 L 781 813.5 L 783 834.5 L 788 860.5 L 799 900.5 L 812 936.5 Q 845.8 1017.7 906.5 1072 Q 963 1123.5 1045.5 1149 L 1076.5 1157 L 1104.5 1162 L 1110.5 1162 L 1111.5 1163 L 1119.5 1163 L 1120.5 1164 L 1142.5 1165 L 1143.5 1166 L 1200.5 1166 L 1201.5 1165 L 1225.5 1164 L 1226.5 1163 L 1234.5 1163 L 1235.5 1162 L 1255.5 1160 L 1352.5 1138 L 1357.5 1138 L 1387.5 1132 L 1415.5 1129 L 1416.5 1128 L 1443.5 1126 L 1444.5 1125 L 1455.5 1125 L 1456.5 1124 L 1469.5 1124 L 1470.5 1123 L 1487.5 1123 L 1488.5 1122 L 1557.5 1122 L 1558.5 1123 L 1575.5 1123 L 1576.5 1124 L 1598.5 1125 L 1599.5 1126 L 1607.5 1126 L 1608.5 1127 L 1615.5 1127 L 1616.5 1128 L 1647.5 1132 L 1691.5 1142 L 1726.5 1153 Q 1806.1 1181.4 1862 1233.5 L 1866 1240.5 L 1867 1250.5 Q 1865.3 1261.8 1857.5 1267 Q 1851.5 1272.5 1838.5 1271 L 1828.5 1266 Q 1810 1248 1787.5 1234 L 1743.5 1210 Q 1718.6 1198.4 1690.5 1190 L 1660.5 1182 L 1629.5 1176 L 1629 1177.5 L 1641 1198.5 L 1647 1216.5 L 1649 1226.5 L 1649 1234.5 L 1650 1235.5 L 1650 1252.5 L 1646 1275.5 L 1637 1297.5 Q 1655.4 1311.1 1670 1328.5 Q 1696.6 1358.9 1710 1402.5 L 1714 1417.5 L 1719 1446.5 L 1719 1457.5 L 1720 1458.5 L 1720 1499.5 L 1719 1500.5 L 1719 1511.5 L 1718 1512.5 L 1715 1539.5 L 1703 1589.5 Q 1688.6 1637.1 1668 1678.5 Q 1648 1719 1623 1754.5 Q 1596.9 1791.9 1563.5 1822 Q 1539.5 1844 1507.5 1858 L 1479.5 1866 Q 1474 1864.5 1472.5 1867 L 1451.5 1867 L 1431.5 1863 L 1414.5 1856 Q 1391.3 1843.2 1375 1823.5 Q 1355.5 1800.5 1342 1771.5 L 1328 1737.5 L 1318 1705.5 L 1311 1676.5 L 1303 1630.5 L 1301 1605.5 L 1300 1604.5 L 1300 1593.5 L 1299 1592.5 L 1299 1578.5 L 1298 1577.5 L 1298 1545.5 Q 1295.2 1543.8 1297 1537.5 L 1298 1536.5 L 1298 1505.5 L 1299 1504.5 L 1299 1491.5 L 1300 1490.5 L 1302 1463.5 L 1309 1425.5 L 1319 1391.5 Q 1338.6 1335.1 1378.5 1299 Q 1395.8 1282.4 1419 1273 L 1416 1254.5 L 1416 1232.5 L 1417 1231.5 L 1418 1219.5 L 1423 1202.5 L 1429 1189.5 L 1440 1172 L 1437.5 1173 L 1413.5 1175 L 1412.5 1176 L 1406.5 1176 L 1405.5 1177 L 1399.5 1177 L 1398.5 1178 L 1392.5 1178 L 1368.5 1183 L 1363.5 1183 L 1282.5 1202 L 1254.5 1207 L 1230.5 1209 L 1229.5 1210 L 1220.5 1210 L 1219.5 1211 L 1206.5 1211 L 1205.5 1212 L 1161.5 1213 L 1160.5 1212 L 1123.5 1211 L 1122.5 1210 L 1113.5 1210 L 1112.5 1209 L 1084.5 1206 L 1059.5 1201 L 1019.5 1190 Q 953.4 1168.1 903.5 1130 L 902 1132.5 L 900 1150.5 L 894 1168.5 Q 883.5 1193.5 864.5 1210 Q 850.7 1222.2 833 1230.5 L 836 1242.5 L 838 1263.5 L 839 1264.5 L 839 1296.5 L 838 1297.5 L 838 1306.5 L 837 1307.5 L 836 1318.5 L 831 1339.5 Q 823.2 1365.2 811 1386.5 Q 784 1433 744.5 1467 Q 675 1527.5 581.5 1564 L 537.5 1579 L 491.5 1590 L 473.5 1592 L 472.5 1593 L 465.5 1593 L 464.5 1594 L 454.5 1594 L 453.5 1595 L 413.5 1595 L 412.5 1594 L 403.5 1594 L 382.5 1590 L 359.5 1582 Q 338.7 1572.3 324 1556.5 Q 308.7 1540.3 301 1516.5 L 296 1492.5 L 295 1461.5 L 296 1460.5 L 296 1449.5 L 297 1448.5 L 299 1429.5 L 308 1393.5 Q 321.6 1351.1 341 1314.5 Q 389.7 1222.7 460.5 1153 Q 500 1113 553.5 1087 Q 577.6 1075.6 607.5 1070 L 622.5 1069 L 623.5 1068 L 654.5 1068 L 679 1072 Q 689.2 1048 708.5 1032 Q 723.5 1019 743.5 1011 L 766.5 1005 L 792.5 1004 L 794 1004.5 L 771 958.5 L 762 935.5 L 747 887.5 L 739 851.5 L 736 826.5 L 735 825.5 L 734 807.5 L 733 806.5 L 733 794.5 L 732 793.5 L 731 753.5 L 732 752.5 L 733 712.5 L 734 711.5 L 734 701.5 L 735 700.5 L 735 692.5 L 736 691.5 L 738 674.5 Q 674.5 604.5 633 512.5 L 605 442.5 L 585 378.5 L 562 291.5 L 547 247.5 L 536.5 224 L 526 248.5 Q 516.5 265 502.5 277 L 485 289.5 L 490 304.5 L 494 322.5 L 497 356.5 L 496 357.5 L 495 383.5 L 489 411.5 Q 480.9 438.9 468 461.5 Q 438.8 511.8 396.5 549 Q 334.3 605.3 252.5 642 Q 217 658 175.5 668 L 153.5 672 L 146.5 672 L 145.5 673 L 109.5 674 L 108.5 673 L 99.5 673 L 98.5 672 L 87.5 671 L 62.5 663 Q 42.6 653.9 29 638.5 Q 13.2 621.3 6 595.5 L 1 568.5 L 1 527.5 L 2 526.5 L 2 517.5 L 8 483.5 L 17 450.5 L 33 406.5 L 57 355.5 Q 78.6 314.6 105 278.5 Q 131.4 241.9 164.5 212 Q 197.3 181.8 242.5 164 L 258.5 159 L 278.5 155 Q 284.8 156.8 286.5 154 L 317.5 154 L 322 155 Q 331 126.9 351.5 109 Q 368.8 93.3 393 84.5 L 371.5 77 L 345.5 70 L 311.5 63 L 271.5 58 L 270.5 57 L 242.5 55 L 241.5 54 L 231.5 54 L 230.5 53 L 219.5 53 L 218.5 52 L 188.5 51 L 187.5 50 L 168.5 50 L 167.5 49 L 103.5 48 L 102.5 47 L 21.5 47 Q 12.1 44.9 7 38.5 L 3 31.5 L 2 20.5 Q 3.9 8.9 12.5 4 L 19.5 1 Z M 419 126 Q 399 129 387 140 Q 373 150 367 167 Q 401 181 427 204 Q 448 223 464 247 L 470 244 Q 489 230 494 202 L 494 183 L 492 174 Q 488 160 480 151 Q 469 136 450 129 L 438 126 L 419 126 Z M 292 200 L 270 204 Q 251 209 236 218 Q 211 232 192 250 Q 164 276 142 307 Q 117 341 97 380 L 76 425 L 62 463 L 52 500 L 48 523 L 48 531 L 47 532 L 47 566 Q 50 567 48 573 Q 51 592 61 605 Q 69 615 83 621 L 99 626 L 115 627 L 116 628 L 141 627 L 181 619 Q 212 610 240 597 Q 315 562 373 508 Q 405 479 427 440 Q 438 420 445 397 L 450 370 L 450 343 L 445 316 Q 434 281 413 257 Q 388 226 350 209 L 322 201 Q 316 203 315 200 L 292 200 Z M 1153 313 L 1152 314 L 1125 316 L 1093 322 L 1066 329 L 1019 346 Q 960 371 917 410 Q 819 502 787 661 Q 850 725 939 763 L 982 779 L 1039 794 L 1079 801 L 1094 802 L 1095 803 L 1127 805 L 1128 806 L 1144 806 L 1145 807 L 1186 807 L 1187 806 L 1197 806 L 1226 801 L 1254 793 Q 1305 774 1343 741 Q 1381 707 1405 658 Q 1414 638 1420 615 L 1424 594 L 1425 574 L 1426 573 L 1426 547 L 1425 546 L 1424 527 L 1423 526 L 1421 509 L 1413 480 Q 1395 429 1362 394 Q 1326 353 1272 330 L 1249 322 L 1210 314 L 1202 314 L 1201 313 L 1153 313 Z M 779 1050 L 759 1055 Q 746 1060 737 1069 L 725 1084 L 723 1090 Q 748 1102 768 1121 Q 797 1148 817 1186 L 831 1178 Q 852 1162 857 1131 L 857 1114 L 855 1104 Q 851 1088 842 1078 Q 831 1063 813 1055 L 800 1051 L 779 1050 Z M 628 1114 L 627 1115 L 609 1117 L 591 1122 L 556 1138 Q 526 1155 502 1178 Q 436 1239 391 1321 Q 372 1354 358 1392 L 346 1432 L 342 1455 L 342 1467 L 341 1468 L 342 1489 L 344 1499 Q 348 1512 355 1522 Q 365 1533 380 1540 L 399 1546 L 410 1548 L 418 1548 L 419 1549 L 452 1549 L 453 1548 L 471 1547 L 498 1542 L 525 1535 L 573 1518 Q 656 1484 719 1428 Q 749 1401 770 1365 Q 780 1346 787 1325 L 791 1308 L 792 1293 L 793 1292 L 793 1270 L 792 1269 L 791 1254 L 783 1225 Q 771 1193 750 1170 Q 726 1141 690 1124 L 673 1118 L 659 1115 Q 652 1117 651 1114 L 628 1114 Z M 1524 1173 Q 1501 1177 1488 1189 Q 1477 1198 1470 1211 L 1465 1223 L 1462 1237 L 1462 1248 Q 1465 1249 1463 1256 L 1465 1257 L 1476 1256 L 1477 1255 L 1486 1255 L 1487 1254 L 1520 1254 L 1521 1255 L 1530 1255 L 1531 1256 L 1543 1257 L 1572 1264 L 1597 1274 L 1602 1261 L 1603 1250 L 1604 1249 L 1603 1232 L 1599 1218 Q 1594 1206 1586 1197 Q 1575 1184 1558 1177 L 1542 1173 L 1524 1173 Z M 1490 1300 L 1489 1301 L 1481 1301 L 1470 1303 L 1450 1309 Q 1429 1317 1414 1330 Q 1396 1344 1384 1364 Q 1371 1383 1363 1407 L 1351 1451 L 1349 1468 L 1348 1469 L 1348 1476 L 1347 1477 L 1346 1495 L 1345 1496 L 1345 1510 L 1344 1511 L 1344 1570 L 1345 1571 L 1345 1586 L 1346 1587 L 1346 1598 L 1347 1599 L 1347 1608 L 1348 1609 L 1350 1631 L 1357 1669 L 1367 1707 L 1381 1745 Q 1393 1773 1412 1796 Q 1422 1806 1435 1814 L 1447 1819 L 1456 1821 L 1474 1820 L 1495 1813 Q 1519 1800 1539 1782 Q 1566 1756 1588 1724 Q 1612 1690 1630 1651 L 1650 1603 L 1662 1565 L 1670 1529 L 1672 1508 L 1673 1507 L 1673 1495 L 1674 1494 L 1674 1463 L 1673 1462 L 1673 1452 L 1667 1421 Q 1656 1383 1633 1357 Q 1608 1327 1569 1312 L 1547 1305 L 1532 1302 L 1516 1301 L 1515 1300 L 1490 1300 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'FairyLightsSecond')

export default icon
